/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*
 * jQuery Easing v1.3.2 - http://gsgd.co.uk/sandbox/jquery/easing/
 * Open source under the BSD License.
 * Copyright © 2008 George McGinley Smith
 * All rights reserved.
 * https://raw.github.com/gdsmith/jquery-easing/master/LICENSE
*/
(function(h){h.easing.jswing=h.easing.swing;h.extend(h.easing,{def:"easeOutQuad",swing:function(e,a,c,b,d){return h.easing[h.easing.def](e,a,c,b,d)},easeInQuad:function(e,a,c,b,d){return b*(a/=d)*a+c},easeOutQuad:function(e,a,c,b,d){return-b*(a/=d)*(a-2)+c},easeInOutQuad:function(e,a,c,b,d){return 1>(a/=d/2)?b/2*a*a+c:-b/2*(--a*(a-2)-1)+c},easeInCubic:function(e,a,c,b,d){return b*(a/=d)*a*a+c},easeOutCubic:function(e,a,c,b,d){return b*((a=a/d-1)*a*a+1)+c},easeInOutCubic:function(e,a,c,b,d){return 1>
(a/=d/2)?b/2*a*a*a+c:b/2*((a-=2)*a*a+2)+c},easeInQuart:function(e,a,c,b,d){return b*(a/=d)*a*a*a+c},easeOutQuart:function(e,a,c,b,d){return-b*((a=a/d-1)*a*a*a-1)+c},easeInOutQuart:function(e,a,c,b,d){return 1>(a/=d/2)?b/2*a*a*a*a+c:-b/2*((a-=2)*a*a*a-2)+c},easeInQuint:function(e,a,c,b,d){return b*(a/=d)*a*a*a*a+c},easeOutQuint:function(e,a,c,b,d){return b*((a=a/d-1)*a*a*a*a+1)+c},easeInOutQuint:function(e,a,c,b,d){return 1>(a/=d/2)?b/2*a*a*a*a*a+c:b/2*((a-=2)*a*a*a*a+2)+c},easeInSine:function(e,a,
c,b,d){return-b*Math.cos(a/d*(Math.PI/2))+b+c},easeOutSine:function(e,a,c,b,d){return b*Math.sin(a/d*(Math.PI/2))+c},easeInOutSine:function(e,a,c,b,d){return-b/2*(Math.cos(Math.PI*a/d)-1)+c},easeInExpo:function(e,a,c,b,d){return 0==a?c:b*Math.pow(2,10*(a/d-1))+c},easeOutExpo:function(e,a,c,b,d){return a==d?c+b:b*(-Math.pow(2,-10*a/d)+1)+c},easeInOutExpo:function(e,a,c,b,d){return 0==a?c:a==d?c+b:1>(a/=d/2)?b/2*Math.pow(2,10*(a-1))+c:b/2*(-Math.pow(2,-10*--a)+2)+c},easeInCirc:function(e,a,c,b,d){return-b*
(Math.sqrt(1-(a/=d)*a)-1)+c},easeOutCirc:function(e,a,c,b,d){return b*Math.sqrt(1-(a=a/d-1)*a)+c},easeInOutCirc:function(e,a,c,b,d){return 1>(a/=d/2)?-b/2*(Math.sqrt(1-a*a)-1)+c:b/2*(Math.sqrt(1-(a-=2)*a)+1)+c},easeInElastic:function(e,a,c,b,d){e=1.70158;var f=0,g=b;if(0==a)return c;if(1==(a/=d))return c+b;f||(f=.3*d);g<Math.abs(b)?(g=b,e=f/4):e=f/(2*Math.PI)*Math.asin(b/g);return-(g*Math.pow(2,10*--a)*Math.sin(2*(a*d-e)*Math.PI/f))+c},easeOutElastic:function(e,a,c,b,d){e=1.70158;var f=0,g=b;if(0==
a)return c;if(1==(a/=d))return c+b;f||(f=.3*d);g<Math.abs(b)?(g=b,e=f/4):e=f/(2*Math.PI)*Math.asin(b/g);return g*Math.pow(2,-10*a)*Math.sin(2*(a*d-e)*Math.PI/f)+b+c},easeInOutElastic:function(e,a,c,b,d){e=1.70158;var f=0,g=b;if(0==a)return c;if(2==(a/=d/2))return c+b;f||(f=.3*d*1.5);g<Math.abs(b)?(g=b,e=f/4):e=f/(2*Math.PI)*Math.asin(b/g);return 1>a?-.5*g*Math.pow(2,10*--a)*Math.sin(2*(a*d-e)*Math.PI/f)+c:g*Math.pow(2,-10*--a)*Math.sin(2*(a*d-e)*Math.PI/f)*.5+b+c},easeInBack:function(e,a,c,b,d,f){void 0==
f&&(f=1.70158);return b*(a/=d)*a*((f+1)*a-f)+c},easeOutBack:function(e,a,c,b,d,f){void 0==f&&(f=1.70158);return b*((a=a/d-1)*a*((f+1)*a+f)+1)+c},easeInOutBack:function(e,a,c,b,d,f){void 0==f&&(f=1.70158);return 1>(a/=d/2)?b/2*a*a*(((f*=1.525)+1)*a-f)+c:b/2*((a-=2)*a*(((f*=1.525)+1)*a+f)+2)+c},easeInBounce:function(e,a,c,b,d){return b-h.easing.easeOutBounce(e,d-a,0,b,d)+c},easeOutBounce:function(e,a,c,b,d){return(a/=d)<1/2.75?7.5625*b*a*a+c:a<2/2.75?b*(7.5625*(a-=1.5/2.75)*a+.75)+c:a<2.5/2.75?b*(7.5625*
(a-=2.25/2.75)*a+.9375)+c:b*(7.5625*(a-=2.625/2.75)*a+.984375)+c},easeInOutBounce:function(e,a,c,b,d){return a<d/2?.5*h.easing.easeInBounce(e,2*a,0,b,d)+c:.5*h.easing.easeOutBounce(e,2*a-d,0,b,d)+.5*b+c}})})(jQuery);


/* https://css-tricks.com/snippets/jquery/smooth-scrolling/ */
$(function() {
  $('a[href*="#"]:not([href="#"])').on('click', function() {
    if ( location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname && !$(this).hasClass("no-move") ) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 500);
        return false;
      }
    }
  });
});

// http://www.paulirish.com/2009/throttled-smartresize-jquery-event-handler/
!function(n,r){var t=function(n,r,t){var e;return function(){function i(){t||n.apply(u,a),e=null}var u=this,a=arguments;e?clearTimeout(e):t&&n.apply(u,a),e=setTimeout(i,r||100)}};jQuery.fn[r]=function(n){return n?this.bind("resize",t(n)):this.trigger(r)}}(jQuery,"smartresize");

/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-objectfit-setclasses !*/
!function(e,n,t){function r(e,n){return typeof e===n}function o(){var e,n,t,o,i,s,a;for(var f in g)if(g.hasOwnProperty(f)){if(e=[],n=g[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(o=r(n.fn,"function")?n.fn():n.fn,i=0;i<e.length;i++)s=e[i],a=s.split("."),1===a.length?Modernizr[a[0]]=o:(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=o),y.push((o?"":"no-")+a.join("-"))}}function i(e){var n=_.className,t=Modernizr._config.classPrefix||"";if(w&&(n=n.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(r,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),w?_.className.baseVal=n:_.className=n)}function s(e){return e.replace(/([a-z])-([a-z])/g,function(e,n,t){return n+t.toUpperCase()}).replace(/^-/,"")}function a(e,n){return!!~(""+e).indexOf(n)}function f(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):w?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function l(e,n){return function(){return e.apply(n,arguments)}}function u(e,n,t){var o;for(var i in e)if(e[i]in n)return t===!1?e[i]:(o=n[e[i]],r(o,"function")?l(o,t||n):o);return!1}function p(e){return e.replace(/([A-Z])/g,function(e,n){return"-"+n.toLowerCase()}).replace(/^ms-/,"-ms-")}function d(){var e=n.body;return e||(e=f(w?"svg":"body"),e.fake=!0),e}function c(e,t,r,o){var i,s,a,l,u="modernizr",p=f("div"),c=d();if(parseInt(r,10))for(;r--;)a=f("div"),a.id=o?o[r]:u+(r+1),p.appendChild(a);return i=f("style"),i.type="text/css",i.id="s"+u,(c.fake?c:p).appendChild(i),c.appendChild(p),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(n.createTextNode(e)),p.id=u,c.fake&&(c.style.background="",c.style.overflow="hidden",l=_.style.overflow,_.style.overflow="hidden",_.appendChild(c)),s=t(p,e),c.fake?(c.parentNode.removeChild(c),_.style.overflow=l,_.offsetHeight):p.parentNode.removeChild(p),!!s}function m(n,r){var o=n.length;if("CSS"in e&&"supports"in e.CSS){for(;o--;)if(e.CSS.supports(p(n[o]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var i=[];o--;)i.push("("+p(n[o])+":"+r+")");return i=i.join(" or "),c("@supports ("+i+") { #modernizr { position: absolute; } }",function(e){return"absolute"==getComputedStyle(e,null).position})}return t}function v(e,n,o,i){function l(){p&&(delete z.style,delete z.modElem)}if(i=r(i,"undefined")?!1:i,!r(o,"undefined")){var u=m(e,o);if(!r(u,"undefined"))return u}for(var p,d,c,v,h,y=["modernizr","tspan","samp"];!z.style&&y.length;)p=!0,z.modElem=f(y.shift()),z.style=z.modElem.style;for(c=e.length,d=0;c>d;d++)if(v=e[d],h=z.style[v],a(v,"-")&&(v=s(v)),z.style[v]!==t){if(i||r(o,"undefined"))return l(),"pfx"==n?v:!0;try{z.style[v]=o}catch(g){}if(z.style[v]!=h)return l(),"pfx"==n?v:!0}return l(),!1}function h(e,n,t,o,i){var s=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+b.join(s+" ")+s).split(" ");return r(n,"string")||r(n,"undefined")?v(a,n,o,i):(a=(e+" "+S.join(s+" ")+s).split(" "),u(a,n,t))}var y=[],g=[],C={_version:"3.3.1",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){g.push({name:e,fn:n,options:t})},addAsyncTest:function(e){g.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=C,Modernizr=new Modernizr;var _=n.documentElement,w="svg"===_.nodeName.toLowerCase(),x="Moz O ms Webkit",S=C._config.usePrefixes?x.toLowerCase().split(" "):[];C._domPrefixes=S;var b=C._config.usePrefixes?x.split(" "):[];C._cssomPrefixes=b;var E=function(n){var r,o=prefixes.length,i=e.CSSRule;if("undefined"==typeof i)return t;if(!n)return!1;if(n=n.replace(/^@/,""),r=n.replace(/-/g,"_").toUpperCase()+"_RULE",r in i)return"@"+n;for(var s=0;o>s;s++){var a=prefixes[s],f=a.toUpperCase()+"_"+r;if(f in i)return"@-"+a.toLowerCase()+"-"+n}return!1};C.atRule=E;var j={elem:f("modernizr")};Modernizr._q.push(function(){delete j.elem});var z={style:j.elem.style};Modernizr._q.unshift(function(){delete z.style}),C.testAllProps=h;var N=C.prefixed=function(e,n,t){return 0===e.indexOf("@")?E(e):(-1!=e.indexOf("-")&&(e=s(e)),n?h(e,n,t):h(e,"pfx"))};Modernizr.addTest("objectfit",!!N("objectFit"),{aliases:["object-fit"]}),o(),i(y),delete C.addTest,delete C.addAsyncTest;for(var P=0;P<Modernizr._q.length;P++)Modernizr._q[P]();e.Modernizr=Modernizr}(window,document);


/*!
  Zoom 1.7.15
  license: MIT
  http://www.jacklmoore.com/zoom
*/
//(function($){var defaults={url:false,callback:false,target:false,duration:120,on:"mouseover",touch:true,onZoomIn:false,onZoomOut:false,magnify:1};$.zoom=function(target,source,img,magnify){var targetHeight,targetWidth,sourceHeight,sourceWidth,xRatio,yRatio,offset,$target=$(target),position=$target.css("position"),$source=$(source);$target.css("position",/(absolute|fixed)/.test(position)?position:"relative");$target.css("overflow","hidden");img.style.width=img.style.height="";$(img).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:img.width*magnify,height:img.height*magnify,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(target);return{init:function(){targetWidth=$target.outerWidth();targetHeight=$target.outerHeight();if(source===$target[0]){sourceWidth=targetWidth;sourceHeight=targetHeight}else{sourceWidth=$source.outerWidth();sourceHeight=$source.outerHeight()}xRatio=(img.width-targetWidth)/sourceWidth;yRatio=(img.height-targetHeight)/sourceHeight;offset=$source.offset()},move:function(e){var left=e.pageX-offset.left,top=e.pageY-offset.top;top=Math.max(Math.min(top,sourceHeight),0);left=Math.max(Math.min(left,sourceWidth),0);img.style.left=left*-xRatio+"px";img.style.top=top*-yRatio+"px"}}};$.fn.zoom=function(options){return this.each(function(){var settings=$.extend({},defaults,options||{}),target=settings.target||this,source=this,$source=$(source),$target=$(target),img=document.createElement("img"),$img=$(img),mousemove="mousemove.zoom",clicked=false,touched=false,$urlElement;if(!settings.url){$urlElement=$source.find("img");if($urlElement[0]){settings.url=$urlElement.data("src")||$urlElement.attr("src")}if(!settings.url){return}}(function(){var position=$target.css("position");var overflow=$target.css("overflow");$source.one("zoom.destroy",function(){$source.off(".zoom");$target.css("position",position);$target.css("overflow",overflow);$img.remove()})})();img.onload=function(){var zoom=$.zoom(target,source,img,settings.magnify);function start(e){zoom.init();zoom.move(e);$img.stop().fadeTo($.support.opacity?settings.duration:0,1,$.isFunction(settings.onZoomIn)?settings.onZoomIn.call(img):false)}function stop(){$img.stop().fadeTo(settings.duration,0,$.isFunction(settings.onZoomOut)?settings.onZoomOut.call(img):false)}if(settings.on==="grab"){$source.on("mousedown.zoom",function(e){if(e.which===1){$(document).one("mouseup.zoom",function(){stop();$(document).off(mousemove,zoom.move)});start(e);$(document).on(mousemove,zoom.move);e.preventDefault()}})}else if(settings.on==="click"){$source.on("click.zoom",function(e){if(clicked){return}else{clicked=true;start(e);$(document).on(mousemove,zoom.move);$(document).one("click.zoom",function(){stop();clicked=false;$(document).off(mousemove,zoom.move)});return false}})}else if(settings.on==="toggle"){$source.on("click.zoom",function(e){if(clicked){stop()}else{start(e)}clicked=!clicked})}else if(settings.on==="mouseover"){zoom.init();$source.on("mouseenter.zoom",start).on("mouseleave.zoom",stop).on(mousemove,zoom.move)}if(settings.touch){$source.on("touchstart.zoom",function(e){e.preventDefault();if(touched){touched=false;stop()}else{touched=true;start(e.originalEvent.touches[0]||e.originalEvent.changedTouches[0])}}).on("touchmove.zoom",function(e){e.preventDefault();zoom.move(e.originalEvent.touches[0]||e.originalEvent.changedTouches[0])}).on("touchend.zoom",function(e){e.preventDefault();if(touched){touched=false;stop()}})}if($.isFunction(settings.callback)){settings.callback.call(img)}};img.src=settings.url})};$.fn.zoom.defaults=defaults})(window.jQuery);


/*! Copyright 2012, Ben Lin (http://dreamerslab.com/)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Version: 1.0.19
 *
 * Requires: jQuery >= 1.2.3
 */
(function(a){if(typeof define==="function"&&define.amd){define(["jquery"],a);
}else{a(jQuery);}}(function(a){a.fn.addBack=a.fn.addBack||a.fn.andSelf;a.fn.extend({actual:function(b,l){if(!this[b]){throw'$.actual => The jQuery method "'+b+'" you called does not exist';
}var f={absolute:false,clone:false,includeMargin:false,display:"block"};var i=a.extend(f,l);var e=this.eq(0);var h,j;if(i.clone===true){h=function(){var m="position: absolute !important; top: -1000 !important; ";
e=e.clone().attr("style",m).appendTo("body");};j=function(){e.remove();};}else{var g=[];var d="";var c;h=function(){c=e.parents().addBack().filter(":hidden");
d+="visibility: hidden !important; display: "+i.display+" !important; ";if(i.absolute===true){d+="position: absolute !important; ";}c.each(function(){var m=a(this);
var n=m.attr("style");g.push(n);m.attr("style",n?n+";"+d:d);});};j=function(){c.each(function(m){var o=a(this);var n=g[m];if(n===undefined){o.removeAttr("style");
}else{o.attr("style",n);}});};}h();var k=/(outer)/.test(b)?e[b](i.includeMargin):e[b]();j();return k;}});}));


/**************************
 * Detect Touch Device
*****************************/
const isTouchDevice = matchMedia('(hover: none)').matches;



/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),

    // Navigation
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};


timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');

  timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
    'onDrawerOpen': ajaxCart.load
  });

};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("カートに入れる");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("売り切れ");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("Translation missing: ja.products.product.compare_at" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }
  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Translation missing: ja.products.product.unavailable");
    $quantityElements.hide();
  }
};


timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

timber.getWindowWidth = function() {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
};

/*============================================================================
  Sticky product info
==============================================================================*/
timber.rc_sticky_product = function () {
  var $window = $(window);
  var $windowHeight = $window.height();
  var $html = $('html');
  var $scrollTop = $window.scrollTop();
  var $lastScrollTop = $scrollTop;
  var $scrollingDown = true;
  var $stickyContainer = $('.product-sticky');
  var $stickyContainerHeight = $stickyContainer.outerHeight();
  var $stickyContent = $stickyContainer.find('.sticky-item');
  var $stickyContentHeight = $stickyContent.outerHeight();
  var $panelPipsProduct = $('.panel-pips--product');
  var $pipsTop = 0;

  $stickyContent.addClass('state--sticky-initialized');

  function checkStickyContent() {
    // check if sticky content height has changed and release from top/bottom if it has
    var $newStickyContentHeight = $stickyContent.outerHeight();
    $pipsTop = $panelPipsProduct.offset().top;

    if($newStickyContentHeight !== $stickyContentHeight) {
      $stickyContent.removeClass('state--anchor-top').removeClass('state--anchor-bottom');
    }
    $stickyContentHeight = $newStickyContentHeight;

    // set min-height on sticky container so that we don't run into any overflow issues
    $stickyContainer.css({ 'min-height': $stickyContentHeight+'px' });
    $stickyContainerHeight = $stickyContainer.outerHeight();

    // set offset top and offset bottom values
    var $offsetTop = $stickyContainer.offset().top;
    var $offsetBottom = $offsetTop + $stickyContainerHeight - $windowHeight;

    // set absolute top
    var $absoluteTop = $scrollTop;

    // set fixed top
    var $fixedTop = $offsetTop;
    $html.get(0).style.setProperty('--fixed-top', $fixedTop+'px');

    // set fixed bottom
    var $fixedBottom = $windowHeight - $stickyContentHeight;
    $html.get(0).style.setProperty('--fixed-bottom', $fixedBottom+'px');

    // set rock bottom
    var $rockBottom = $offsetBottom;

    // check scroll direction
    $scrollingDown = ($scrollTop > $lastScrollTop);

    // if sticky content fits within the viewport, anchor to the top until you hit rock bottom
    if($stickyContentHeight < ($windowHeight - $offsetTop)) {
      // release from bottom
      $stickyContent.removeClass('state--anchor-bottom');

      // anchor to top
      $stickyContent.addClass('state--anchor-top');

      // record absolute position
      $html.get(0).style.setProperty('--absolute-top', Math.round($stickyContent.offset().top - $offsetTop)+'px');

      // if bottom of sticky content hits bottom of the viewport
      $rockBottom = $offsetBottom + ($windowHeight - $offsetTop - $stickyContentHeight);
      if($scrollTop >= $rockBottom) {
        $stickyContent.removeClass('state--anchor-top').addClass('state--rock-bottom');
        $panelPipsProduct.addClass('scroll').css('top', $pipsTop);
        $html.get(0).style.setProperty('--absolute-top', Math.round($stickyContainerHeight - $stickyContentHeight)+'px');
      } else {
        $stickyContent.removeClass('state--rock-bottom');
        $panelPipsProduct.removeClass('scroll').removeAttr('style');
      }

    // if scrolling down
    } else if($scrollingDown) {
      // release from top
      $stickyContent.removeClass('state--anchor-top');

      // set current scrolling state
      $stickyContent.removeClass('state--scrolling-up').addClass('state--scrolling-down');

      // if bottom of sticky content hits the bottom of the viewport
      if($scrollTop >= ($stickyContent.offset().top + $stickyContentHeight - $windowHeight)) {

        // set anchor to bottom state
        $stickyContent.addClass('state--anchor-bottom');
      }

      // if bottom of sticky container hits bottom of the viewport
      if($scrollTop >= $rockBottom) {
        $stickyContent.removeClass('state--anchor-bottom').addClass('state--rock-bottom');
        $panelPipsProduct.addClass('scroll').css('top', $pipsTop);
        $html.get(0).style.setProperty('--absolute-top', Math.round($stickyContainerHeight - $stickyContentHeight)+'px');
      } else {
        $stickyContent.removeClass('state--rock-bottom');
        $panelPipsProduct.removeClass('scroll').removeAttr('style');
      }

      // record absolute-top position
      if($stickyContent.hasClass('state--anchor-bottom')) {
        $html.get(0).style.setProperty('--absolute-top', Math.round($stickyContent.offset().top - $offsetTop)+'px');
      }

    // if scrolling up
    } else {
      // release from bottom
      $stickyContent.removeClass('state--anchor-bottom');

      // set current scrolling state
      $stickyContent.removeClass('state--scrolling-down').addClass('state--scrolling-up');

      // if top of sticky content hits the top of the viewport
      if($scrollTop <= ($stickyContent.offset().top - $offsetTop)) {

        // set anchor to top state
        $stickyContent.addClass('state--anchor-top');
      }

      // if bottom of sticky container hits bottom of the viewport
      if($scrollTop >= $rockBottom) {
        $stickyContent.removeClass('state--anchor-bottom').addClass('state--rock-bottom');
        $panelPipsProduct.addClass('scroll').css('top', $pipsTop);
        $html.get(0).style.setProperty('--absolute-top', Math.round($stickyContainerHeight - $stickyContentHeight)+'px');
      } else {
        $stickyContent.removeClass('state--rock-bottom');
        $panelPipsProduct.removeClass('scroll').removeAttr('style');
      }

      // record absolute-top position
      if($stickyContent.hasClass('state--anchor-top')) {
        $html.get(0).style.setProperty('--absolute-top', $absoluteTop+'px');
      }
    }
  }
  //setTimeout(checkStickyContent, 250);

  $window.smartresize(function() {
    $windowHeight = $window.height();

    checkStickyContent();
  });

  $window.scroll(function() {
    $scrollTop = $window.scrollTop();

    //window.requestAnimationFrame(function() {
      checkStickyContent();
      $lastScrollTop = $scrollTop;
    //});
  });
};

timber.checkUserAgent = {

  checkMSIE: function() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if ( (msie > 0) || !!navigator.userAgent.match(/Trident.*rv\:11\./) ) { // If Internet Explorer, return version number {
        return true;
    } else { // If another browser, return 0
        return false;
    }
  },
  checkEdge: function() {
    if ( !!navigator.userAgent.match(/Edge/) ) {
        return true;
    } else { // If another browser, return 0
        return false;
    }
  },
  checkFF: function() {
    if ( !!navigator.userAgent.match(/Firefox/) ) {
        return true;
    } else { // If another browser, return 0
        return false;
    }
  }
};


/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer'),
      rc_overlay: $('.overlay'),
      rc_drawerLeft2: $('.drawer--left2'),
      rc_openSecondaryNav: '.js-open-secondary-nav',
      rc_closeSecondaryNav: '.js-close-secondary-nav'
    };

    this.$flags = {
      rc_openDrawerLeft2Flag: 'js-drawer-open-left2'
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);
    this.$rc_drawer = $('#NavDrawer2');

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();

  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));

    $(this.$nodes.rc_closeSecondaryNav).on('click touchend', $.proxy(function(e) {
      e.preventDefault();
      if (timber.getWindowWidth() < 768) {
        this.$nodes.parent.removeClass(this.$flags.rc_openDrawerLeft2Flag);
        this.$nodes.rc_drawerLeft2.removeClass('is-open');
      }
    }, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');

    // TODO:prepareTransition cannot refer to $ only on cart page
    // take a look later
    if ( $(".template-cart").length ) {
      jQuery(this.$drawer).prepareTransition();
      jQuery(this.$rc_drawer).prepareTransition();
    } else {
      this.$drawer.prepareTransition();
      this.$rc_drawer.prepareTransition();
    }

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) === 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // set overlay on #PageContainer
    // TODO:prepareTransition cannot refer to $ only on cart page
    if ( $(".template-cart").length ) {
      jQuery(this.$nodes.rc_overlay).prepareTransition().removeClass('is-hidden');
    } else {
      this.$nodes.rc_overlay.prepareTransition().removeClass('is-hidden');
    }


    // Open secondary menu nav
    if ( timber.cache.$body.hasClass('template-product') || timber.cache.$body.hasClass('template-collection') || timber.cache.$body.hasClass('template-cart') ) {

      // open 2nd drawer -> both 1st and 2nd drawers open on clicking global menu
      // this.$nodes.rc_drawerLeft2.prepareTransition().addClass('is-open');
      // this.$nodes.parent.addClass(this.$flags.rc_openDrawerLeft2Flag);

      // $(this.$nodes.rc_openSecondaryNav).on('click touchend', $.proxy(function(e) {
      //   e.preventDefault(); // prevent hash from being put in url
      // this.$nodes.rc_drawerLeft2.prepareTransition().addClass('is-open');
      // this.$nodes.parent.addClass(this.$flags.rc_openDrawerLeft2Flag);
      // }, this));

      // TODO:prepareTransition cannot refer to $ only on cart page
      if ( $(".template-cart").length ) {
        jQuery(this.$nodes.rc_drawerLeft2).prepareTransition().addClass('is-open');
        this.$nodes.parent.addClass(this.$flags.rc_openDrawerLeft2Flag);

        // $(this.$nodes.rc_openSecondaryNav).on('click touchend', $.proxy(function(e) {
        //   e.preventDefault(); // prevent hash from being put in url
        // jQuery(this.$nodes.rc_drawerLeft2).prepareTransition().addClass('is-open');
        // this.$nodes.parent.addClass(this.$flags.rc_openDrawerLeft2Flag);
        // }, this));
      } else {
        // this.$nodes.rc_drawerLeft2.prepareTransition().addClass('is-open');
        // this.$nodes.parent.addClass(this.$flags.rc_openDrawerLeft2Flag);

        // $(this.$nodes.rc_openSecondaryNav).on('click touchend', $.proxy(function(e) {
        //   e.preventDefault(); // prevent hash from being put in url
        // this.$nodes.rc_drawerLeft2.prepareTransition().addClass('is-open');
        // this.$nodes.parent.addClass(this.$flags.rc_openDrawerLeft2Flag);
        // }, this));
      }

    } else {

      // 2nd drawer opens only on clicking the 2nd grawer nav
      // $(this.$nodes.rc_openSecondaryNav).on('click touchend', $.proxy(function(e) {
      //   e.preventDefault(); // prevent hash from being put in url

      // // TODO:prepareTransition cannot refer to $ only on cart page
      // if ( $(".template-cart").length ) {
      //   jQuery(this.$nodes.rc_drawerLeft2).prepareTransition().addClass('is-open');
      // } else {
      //   this.$nodes.rc_drawerLeft2.prepareTransition().addClass('is-open');
      // }

      //   this.$nodes.parent.addClass(this.$flags.rc_openDrawerLeft2Flag);
      // }, this));

    }

  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    // TODO:prepareTransition cannot refer to $ only on cart page
    if ( $(".template-cart").length ) {
      jQuery(this.$nodes.moved).prepareTransition({ disableExisting: true });
      jQuery(this.$drawer).prepareTransition({ disableExisting: true });
      jQuery(this.$nodes.rc_drawerLeft2).prepareTransition({ disableExisting: true });
    } else {
      this.$nodes.moved.prepareTransition({ disableExisting: true });
      this.$drawer.prepareTransition({ disableExisting: true });
      this.$nodes.rc_drawerLeft2.prepareTransition({ disableExisting: true });
    }


    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass + ' ' + this.$flags.rc_openDrawerLeft2Flag);
    this.$nodes.parent.addClass('pushBack');
    this.$nodes.rc_drawerLeft2.removeClass('is-open');


    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // remove overlay on #PageContainer
    if ( $(".template-cart").length ) {
      jQuery(this.$nodes.rc_overlay).prepareTransition().addClass('is-hidden');
    } else {
      this.$nodes.rc_overlay.prepareTransition().addClass('is-hidden');
    }

  };

  Drawer.prototype.closeSecondaryNav = function() {
    // close secondary nav on mobile
    $(this.$nodes.rc_closeSecondaryNav).on('click touchend', $.proxy(function() {
      // console.log(this);
      if (timber.getWindowWidth() < 768) {
        this.$nodes.parent.removeClass(this.$flags.rc_openDrawerLeft2Flag);
        this.$nodes.rc_drawerLeft2.removeClass('is-open');
      }
    }, this));
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();


/*============================================================================
  Common
==============================================================================*/
timber.rc_global = (function () {

  $cachedbody = $("body");

  /*================ User agent check ================*/
  if ( timber.checkUserAgent.checkMSIE() ) {
    $cachedbody.addClass("ie");
  } else {
    $cachedbody.addClass("not-ie");
  }
  if ( timber.checkUserAgent.checkEdge() ) {
    $cachedbody.addClass("edge");
  }
  if ( timber.checkUserAgent.checkFF() ) {
    $cachedbody.addClass("firefox");
  }

})();





/*============================================================================
  Product page filter
==============================================================================*/
timber.rc_product_filter = (function () {

  /*================ Filter open/close ================*/
  var $toggleFilter = $(".product-menu").find(".js-toggle-filter"),
      $filter = $(".product-filter"),
      $filterClose_mob = $(".js-product-filter-close"); // combined with filter search function below

  $toggleFilter.on('click', function() {
    if (timber.getWindowWidth() > 1024) {
      $toggleFilter.toggleClass('is-open');
    } else {
      $toggleFilter.toggleClass('is-open');
      $filterClose_mob.removeClass('is-hidden');
    }
    $filter.slideToggle(600, 'easeOutExpo');
  });


  /*================ Filter content open/close on mobile ================*/
  var $filtertitle = $(".js-product-filter__title"),
      $filterForm = $(".product-filter__form"),
      $filterSet = $(".product-filter__set"),
      $icon = $(".product-filter .icon-animatable");



  function resizeFilter() {
    if (timber.getWindowWidth() < 1025) {
      $filterForm.hide();
      $filterSet.removeClass('open');
      $icon.addClass('plus');

      $filtertitle.off('click');
      $filtertitle.on('click', function() {
        $(this).next($filterForm).slideToggle(400, 'easeOutExpo');

        $(this).find($icon).toggleClass("plus");
        $(this).parent($filterSet).toggleClass("open");
      });
    }
    else {
      $filtertitle.off('click');
      $filterForm.show();
    }
  }
  resizeFilter();

  var doit;
  $(window).on('resize', function() {
    clearTimeout(doit);
    doit = setTimeout(resizeFilter, 100);
  });

  /*================ Change category link colour only in index page ================*/
  if ($('body').hasClass('template-index')) {
    var $cats = $('.product-categories__item').find('a');
    $cats.each(function() {
      if ( $(this).attr('href').indexOf("all") > -1 ) {
        $(this).addClass('current');
      }
    });
  }

  /*================ Change season tag colour based on a page ================*/
  var $seasonFilter = $(".js-season-filter"),
      $seasonFilter_mob = $(".js-season-filter--mob"),
      seasonTag,
      seasonFilteredFlag = false; // used to indicate current page is under season tag filtered

  if (timber.getWindowWidth() > 767) {
    if ( $seasonFilter.length ) {
      $seasonFilter.each(function() {
        seasonTag = $(this).data('tag');
        if ( window.location.href.indexOf(seasonTag) > -1 ) { // if url contains the tag
          $(this).addClass("current");
          seasonFilteredFlag = true;
          $('.season-filter-all').removeClass('current');
        }
      });
    }
  } else {
    if ( $seasonFilter_mob.length ) {
      $seasonFilter_mob.each(function() {
        seasonTag = $(this).data('tag');
        if ( window.location.href.indexOf(seasonTag) > -1 ) { // if url contains the tag
          $(this).prop("selected", true);
          seasonFilteredFlag = true;
        }
      });
    }
  }

  /*================ Mobile: transit page with select option change ================*/
  var selectedPage;
  if (timber.getWindowWidth() < 768) {
    $(".product-categories--select").on('change', function() {
      selectedPage = $(this).find("option:selected").data("href");
      window.location.href = selectedPage;
      // window.location.href = "//" + window.location.host + selectedPage;
      // console.log("//" + window.location.host + selectedPage);
    });
  }

  function checkCollectionFilter() {
    if( $('.product-categories--select').length >= 1 ) {
      currentURL = window.location.pathname;
      // console.log(currentURL);

      $('.product-categories--select option').each(function() {
        // console.log(this);
        if( $(this).attr('data-href') == currentURL ) {
          // console.log('matches');
          // console.log($(this).attr('data-href'));
          $(this).prop('selected', true);
          // console.log('test');
        }
      });


    }
  }
  checkCollectionFilter();

  /*================ Filtering ================*/
  var selectedTags = [],
      selectedColours = [],
      selectedFits = [],
      selectedSizes = [],
      rcProducts = [],
      setFilters,
      query,
      currentURL,
      newURL,
      reg,
      regUrl,
      baseURL,
      sortedBy = '',
      isIndexPage = $('body').hasClass('template-index');
      // window.onpopstate = function(event) {
      //   outputProducts(rcProducts);
      //   // We use false as the second argument below
      //   // - state will already be on the stack when going Back/Forwards
      //   // createView(event.state, false);
      // };

  // $(window).unload(function() {
  //   console.log('test back');
  //   $(".product-filter__form").find("input").each(function() {
  //     if( $(this).is(':checked')) {
  //       console.log('checkbox is checked');
  //     } else {
  //       console.log('not checked');
  //     }
  //   });
  // });
  // if (location.hash.length > 0) {
  //       console.log(location.hash.length);
  //   } else {
  //       console.log('no-dice');
  //   }

  // window.onhashchange = function() {
  //   if (location.hash.length > 0) {
  //       console.log(location.hash);
  //   } else {
  //       console.log('no-dice');
  //   }
  // }

  // window.unload = function() {
  //   if (location.hash.length > 0) {
  //       console.log(location.hash);
  //   } else {
  //       console.log('no-dice');
  //   }
  // }

  // if(setFilters) {
  //   console.log(setFilters);
  // }


  $(".product-filter__update").on('click', function() {
    // console.log('clicked update');
      selectedTags = [];
      selectedColours = [];
      selectedFits = [];
      selectedSizes = [];
      // sortedBy = '';

      if($('.current-select')) {
        sortedBy = $('.current-select').attr('data-value');
      }
      // console.log(sortedBy);

    document.getElementById('product-grid-wrap').classList.add('loading');
    $("body, html").animate({
        scrollTop: $("#product-grid-wrap").position().top - 70
      });

    $(".product-filter__form").find("input:checked").each(function() {
      if( selectedTags.includes( $(this).val() ) ) {
        //do nothing
      } else {
        selectedTags.push($(this).val());
        if( $(this).val().includes('colour-filter') ) {
          selectedColours.push( $(this).val() );
        }
        else if( $(this).val().includes('fit') ) {
          selectedFits.push( $(this).val() );
        }
        else {
          selectedSizes.push($(this).val() );
        }
      }
    });

    if(selectedColours.length == 0 && selectedFits.length == 0 && selectedSizes.length == 0) {
      var clearUrl = window.location.href.replace(window.location.hash, '');
      // console.log(clearUrl);
      history.pushState(clearUrl, '', clearUrl);
      location.reload();
    } else {

      // console.log(selectedColours);
      // console.log(selectedFits);
      // console.log(selectedSizes);

        getProducts(selectedColours, selectedFits, selectedSizes, sortedBy);

        if(selectedColours.length > 0 && selectedFits.length > 0 && selectedSizes.length > 0) {
          window.location.hash = selectedColours + ',' + selectedFits + ',' + selectedSizes;
        }
        else if(selectedColours.length > 0) {
          window.location.hash = selectedColours;
        }
        else if(selectedFits.length > 0) {
          window.location.hash = selectedFits;
        }
        else {
          window.location.hash = selectedSizes;
        }
    }
  });

  /*================ Filtering fired by clicking Close X on mobile ================*/
  // sorry no time to optimize code, i just copy and paste above ones
  // $filterClose_mob.on('click', function() {

  //   $(".product-filter__form").find("input:checked").each(function() {
  //     selectedTags.push($(this).val());
  //   });
  //   if (selectedTags.length) {
  //     query = selectedTags.join("+");
  //     currentURL = window.location.href;

  //     if (currentURL.indexOf("?") > -1) { // remove "?" used for query to add tags correctly
  //       currentURL = currentURL.replace(/\?.*/g, ""); // remove like "?page=2"
  //     }

  //     if (seasonFilteredFlag) {
  //       reg = /.+?\+/g; //search '+' which is used for tag query
  //       regUrl = currentURL.match(reg);
  //       if (regUrl) {
  //         baseURL = regUrl.toString().replace(/\+$/, ""); // remove last plus if exists
  //       } else {
  //         baseURL = currentURL; // if not, set current one
  //       }
  //       newURL = baseURL + "+" + query;
  //     } else {
  //       reg = /((.+?collections\/(.*)\/)|(.+?collections\/(.*)))/g; //match both collections/TYPE/ and collections/TYPE. TYPE would be like "tops"
  //       regUrl = currentURL.match(reg);
  //       if (regUrl) {
  //         baseURL = regUrl.toString().replace(/\/$/, ""); // remove last slash if exists
  //       } else {
  //         baseURL = currentURL;
  //       }
  //       newURL = baseURL + "/" + query;
  //     }

  //     window.location = newURL;
  //   } else {
  //     $filterClose_mob.addClass('is-hidden');
  //     $filter.slideToggle(400, 'easeOutExpo');
  //   }

  // });

  /*================ Keep checked states after refresh ================*/

  if ( $(".template-collection").length ) {
    var urlPath = window.location.pathname.split("/").pop(),
        $itemInput = $(".product-filter__item").find("input"),
        itemInputValue;

        // console.log(urlPath);

    $itemInput.each(function() {
      itemInputValue = $(this).attr("value");
      // console.log(itemInputValue);

      if ( urlPath.indexOf(itemInputValue) > -1 ) {
        $(this).prop('checked', true).addClass("is-checked");
      }
    });
  }

  /*================ Clear filter checked ================*/
  $(".product-filter__clear").on('click', function() {
    $(".product-filter__form").find("input").prop('checked', false).removeClass("is-checked");
    document.getElementById('product-grid-wrap').classList.add('loading');
    selectedTags = [];
    selectedColours = [];
    selectedFits = [];
    selectedSizes = [];

    if($('.current-select')) {
      sortedBy = $('.current-select').attr('data-value');
    }
    // console.log(sortedBy);

    // getProducts(selectedColours, selectedFits, selectedSizes, sortedBy);

    var $toggleFilter = $(".product-menu").find(".js-toggle-filter"),
      $filter = $(".product-filter"),
      $filterClose_mob = $(".js-product-filter-close"); // combined with filter search function below

      if (timber.getWindowWidth() > 1024) {
        $toggleFilter.toggleClass('is-open');
      } else {
        $toggleFilter.toggleClass('is-open');
        $filterClose_mob.removeClass('is-hidden');
      }
      $filter.slideToggle(600, 'easeOutExpo');


      var clearUrl = window.location.href.replace(window.location.hash, '');
      // console.log(clearUrl);
      history.pushState(clearUrl, '', clearUrl);
      // console.log(selectedTags);
      location.reload();
  });

  /*================ check/uncheck on clicking filter item ================*/
  var $input = $(".product-filter__form").find("input"),
      $self,
      isChecked;

  $input.on('click', function() {
    $self = $(this);
    // console.log($self);
    // console.log(selectedTags);
    $isChecked = $self.hasClass("is-checked"); // cache the flag before clearing below

    // clear all flags in order not to keep is-checked class
    // $self.closest(".product-filter__form").find("input").prop('checked', false).removeClass("is-checked");

    // if ( $isChecked ) {
    //   $self.prop('checked', false).removeClass("is-checked");
    // } else {
    //   $self.prop('checked', true).addClass("is-checked");
    // }
    // console.log($self);
  });


})();

/*============================================================================
  Product page
==============================================================================*/
timber.rc_product_page = (function () {

  if ( $(".template-collection").length ) {
    /*================ Set default size ================*/
    var $productSizeItem = $(".product-size-form__item input"),
        defaultSize = $productSizeItem.find("input:checked").data('size'),
        $sizeDisplay = $("#sizeDisplay"),
        currentSize;

    $sizeDisplay.html(defaultSize);

    $productSizeItem.on('click', function() {
      // console.log($(this).data('size'));
      currentSize = $(this).data('size');

      // if($(this).hasClass('is-available')) {
      //   $('#AddToCart').removeClass('disabled').prop('disabled', false);
      // }

    });
  }

  if ( $(".template-product").length ) {

    /*================ Set default size/color ================*/
    var $productSizeItem = $('.product-size-form__item'),
        $productColorSwatches = $('.colour-swatch-items'),
        $sizeDisplay = $('#sizeDisplay'),
        $colorDisplay = $('#colorDisplay'),
        defaultSize,
        defaultStock,
        currentSizeItem,
        currentSize,
        currentColor,
        colorName,
        currentStock;

    if($productSizeItem.find('input').length === 1 && $productSizeItem.find('input[disabled]').length === 1) {
      defaultSize = $productSizeItem.find('input[disabled]').data('size');
      defaultStock = $productSizeItem.find('input[disabled]').data('stock');
    }
    else {
      defaultSize = $productSizeItem.find('input:checked').data('size');
      defaultStock = $productSizeItem.find('input:checked').data('stock');
    }

    if(defaultSize !== undefined && defaultStock !== undefined){
      if(defaultStock > 5) {
        $sizeDisplay.html(defaultSize);
      }
      else {
        if(defaultStock > 0) {
          $sizeDisplay.html(defaultSize + ' - Only ' + defaultStock + ' Remaining');
        }
        else {
          $sizeDisplay.html(defaultSize + ' - Sold Out');
        }
      }
    }

    $productSizeItem.on('click', function() {

      currentSizeItem = $(this).find('input:checked');

      if(currentSizeItem.length) {
        currentSize = $(this).find('input').data('size');
        currentStock = $(this).find('input').data('stock');

        if(currentStock > 5) {
          $sizeDisplay.html(currentSize);
        }
        else {
          if(currentStock > 0) {
            $sizeDisplay.html(currentSize + ' - Only ' + currentStock + ' Remaining');
          }
          else {
            $sizeDisplay.html(currentSize + ' - Sold Out');
          }
        }

        if($(this).hasClass('is-available')) {
          $('#AddToCart').removeClass('disabled').prop('disabled', false);
        }
      }

    });

    if(!isTouchDevice) {

      // Size Hover
      $productSizeItem.hover(function() {
        currentSize = $(this).find('input').data('size');
        currentStock = $(this).find('input').data('stock');

        if(currentStock > 5) {
          $sizeDisplay.html(currentSize);
        }
        else {
          if(currentStock > 0) {
            $sizeDisplay.html(currentSize + ' - Only ' + currentStock + ' Remaining');
          }
          else {
            $sizeDisplay.html(currentSize + ' - Sold Out');
          }
        }

      }, function() {

        currentSizeItem = $productSizeItem.find('input:checked');

        if(currentSizeItem.length) {

          currentSize = currentSizeItem.data('size');
          currentStock = currentSizeItem.data('stock');

          if(currentStock > 5) {
            $sizeDisplay.html(currentSize);
          }
          else {
            if(currentStock > 0) {
              $sizeDisplay.html(currentSize + ' - Only ' + currentStock + ' Remaining');
            }
            else {
              $sizeDisplay.html(currentSize + ' - Sold Out');
            }
          }
        }
        else {
          $sizeDisplay.html('');
        }

      });

      // Color Hover
      $productColorSwatches.on('mouseenter', 'a.colour-swatch', function() {

        colorName = $(this).data('color-name');
        $colorDisplay.html(colorName);

      }).on('mouseleave', 'a.colour-swatch', function() {

        currentColor = $productColorSwatches.find('.is-current .colour-swatch').data('color-name');
        $colorDisplay.html(currentColor);

      });

    }

    /*================ View cart link ================*/
    var $viewCartLink = $(".view_cart_link"),
        viewCartLinkHasItem = $viewCartLink.data('item-num'),
        $AddToCart = $("#AddToCart");

    if ( viewCartLinkHasItem > 0 ) {
      $viewCartLink.removeClass("is-hidden");
    }

    $AddToCart.on('click', function() {

      if ( $('.product-sizes input').is(':checked') ) {
        $AddToCart.addClass("is-switching-msg");
        setTimeout(function() {
        if ( $viewCartLink.hasClass("is-hidden") ) {
          $viewCartLink.removeClass("is-hidden");
        }
        $AddToCart.removeClass("is-switching-msg");
      }, 1000);
      } else {

        $AddToCart.addClass("no-size-selected");
        setTimeout(function() {
        if ( $viewCartLink.hasClass("is-hidden") ) {
          $viewCartLink.removeClass("is-hidden");
        }
        $AddToCart.removeClass("no-size-selected");
      }, 1000);
      }

    });

    /*================ Overview and Info ================*/
    if ( $(".product-description").find("table").length ) {
      $(".product-description").find("table").parent("div").addClass('table-wrap');
    }
    var $desc = $(".product-description"),
        $descTitle = $desc.find("h2"),
        $descContent = $desc.find("div:not(.table-wrap)"),
        delay,
        $targetTitle,
        descContentId;

    // $descTitle.first().addClass("active").attr("href", "#content1");
    $descTitle.eq(1).addClass("accordion-title").attr("data-accordion", "#content1");
    $descTitle.eq(2).addClass("accordion-title").attr("data-accordion", "#content2");
    $descTitle.eq(3).addClass("accordion-title").attr("data-accordion", "#content3");
    $descTitle.eq(4).addClass("accordion-title").attr("data-accordion", "#content4");

    // $descContent.first().addClass("active").attr("id", "content1");
    $descContent.eq(1).addClass("accordion-content").attr("id", "content1");
    $descContent.eq(2).addClass("accordion-content").attr("id", "content2");
    $descContent.eq(3).addClass("accordion-content").attr("id", "content3");
    $descContent.eq(4).addClass("accordion-content").attr("id", "content4");

    //$descContent.eq(1).insertAfter($descContent.first()); // 2nd div below 1st div

    $descTitle.on('click', function(e) {
      e.preventDefault();

      $targetTitle = $(this);
      descContentId = $targetTitle.attr("data-accordion");

      $targetTitle.toggleClass("active");
      $(descContentId).slideToggle(300);

    });



    /*================ Slick, image gallery ================*/
    // Gallery
    var scrollDistance = 0;

    $('.js-product-zoom').on('click', function(e) {
      e.preventDefault();
      var target = $(this).data('image-id');
      var section = $('#' + target);
      scrollDistance = $(document).scrollTop();

      $('#imageGallery').fadeIn(300);
      $body.addClass('no-scroll');
      section[0].scrollIntoView();
    });

    $('.btn--close-image-gallery, .image-gallery--item').on('click', function() {
      $('#imageGallery').fadeOut(300);
      $body.removeClass('no-scroll');
      $('html, body').animate({
        scrollTop: scrollDistance
      }, 0);
    });

    function responsiveGallery() {
      if (timber.getWindowWidth() < 768) {

        // Slick
        if(!$("#ProductImageList.slick-initialized").length) {
          $("#ProductImageList").slick({
            slidesToShow: 1,
            dots: true
          });
        }

        // Gallery
        //$('.js-product-zoom').off('click');

      }
      else {

        // Slick
        if($("#ProductImageList.slick-initialized").length) {
          $("#ProductImageList").slick('unslick');
        }

      }
    }
    responsiveGallery();

    var checkGallery;
    $(window).on('load resize', function() {
      clearTimeout(checkGallery);
      checkGallery = setTimeout(responsiveGallery, 100);
    });


    /*================ Pips for desktop: similar way as in homepage ================*/
    var $productItem = $('.product-single__photo'),
        panelPip = '',
        pipId,
        $panelPips = $('.panel-pips'),
        $target,
        curIndex;
    if ($productItem.length > 1) {
        $productItem.each(function(index) {
          $target = $(this);
          curIndex = index + 1;
          pipId = $target.attr('id');

          panelPip = panelPip + '<a class="panel-pip ' + pipId + '" href="#' + pipId + '" data-counter="' + curIndex + '" name="image ' + curIndex + '"></a>';
          //$panelPips.append('<a class="panel-pip panel-pip-' + curIndex + " " + pipId + '" href="#' + pipId + '" data-counter="' + curIndex + '"></a>');
        });
        $('.panel-pips').html(panelPip);


      /*================ Scroll handler on product detail page ================*/
      // - change anchor color on scroll
      // - make sticky right info scrollable when window height is smaller than the element

      var scroll = window.requestAnimationFrame ||
                   window.webkitRequestAnimationFrame ||
                   window.mozRequestAnimationFrame ||
                   window.msRequestAnimationFrame ||
                   window.oRequestAnimationFrame ||
                   // IE Fallback, you can even fallback to onscroll
                   function(callback) { window.setTimeout(callback, 1000/60); };

      // for pips
      var distanceY = 0,
          lastPosition = -1,
          $panels,
          $panelPip = $('.panel-pip'),
          i,
          itemCount = $productItem.length,
          colourChangePos = window.innerHeight/2,
          el,
          elPos,
          elTop,
          elBottom,

          $featuredImage = $('.product-featured-images'),
          featuredImageH,
          $productPips = $('.panel-pips--product'),
          offsetScrollAmount;

      /*================ Initialize sticky product info ================*/
      timber.rc_sticky_product();


      function loop() {

        distanceY = window.pageYOffset || document.documentElement.scrollTop;

        // prevent calculation if not scrolled
        if (lastPosition === distanceY) {
            scroll(loop);
            return false;
        } else {
          lastPosition = distanceY;
        }

        // pips colour change
        for (i = 0; i < itemCount; i++) {
          el = $productItem[i];
          elPos = el.getBoundingClientRect();
          elTop = elPos.top;
          elBottom = elPos.bottom;


          if ( elTop < colourChangePos && elBottom > colourChangePos ) {
            $panelPip[i].classList.add("current");
          } else {
            $panelPip[i].classList.remove("current");
          }
        }

        // product info element
        if ( $(".supports-no-touch").length ) {
          // console.log('diff');
          // console.log(diff);
          // console.log('pageY');
          // console.log(distanceY);
          // console.log('stickyElemBottom');
          // console.log(stickyElemBottom);

          if ( featuredImageH > 0 ) { // if featured images, move up sticky elems

            //featuredImageTop = $featuredImage[0].getBoundingClientRect().top;

            // move up a bit earlier not to overlap in scmall screen
            if ( distanceY > (stickyElemBottom - 50) ) {
              // default value minus scroll amount. stickyElemBottom is for offset to start with the scroll value from 0
              offsetScrollAmount = stickyElemBottom - 50 - distanceY;

              $productPips.css({
                transform: 'translateY(' + offsetScrollAmount + 'px)'
              });

            } else {
              $productPips.css({
                transform: ''
              });
            }

          }

        }

        scroll(loop);

      }

      $(window).on('load', loop);

    }

    /*================ Sizing guide overlay ================*/

    // animate open/close the guide
    var $guideOpen = $(".js-open-size-guide"),
        $guideClose = $(".js-close-size-guide"),
        $overlay = $(".overlay--sizing-guide"),
        $html = $("html");
        $body = $("body");

    // prevent scroll
    $guideOpen.on('click', function(event) {
      $overlay.prepareTransition().removeClass('is-hidden');
      $html.addClass("no-scroll");
      $body.addClass("no-scroll");
    });
    $guideClose.on('click', function(event) {
      $overlay.prepareTransition().addClass('is-hidden');
      $html.removeClass("no-scroll");
      $body.removeClass("no-scroll");
    });

    $('.overlay--sizing-guide').on('click', function(e) {
      if (e.target !== this) {
        return;
      }
      $overlay.prepareTransition().addClass('is-hidden');
      $html.removeClass("no-scroll");
      $body.removeClass("no-scroll");
    });

    // Lock scrolling on mobile
    $guideOpen.on('touchmove', function () {
      return false;
    });

    if ( $(".product-description").find("table").length ) {

      // move h4 title
      $(".product-description").find("table").parent("div").appendTo("#sizingGuide__table-cm");
      $("#sizingGuide__table-cm").find("table").clone(true).appendTo("#sizingGuide__table-inch");

      // convert inch to cm in sizing table
      var cmValue,
          inchValue;

      if($("#sizingGuide__content--guide.product-pant").length || $("#sizingGuide__content--guide.product-kid").length) {
        var $convertTarget = $("#sizingGuide__table-inch tr:not(:last-child) td");
      }
      else {
        var $convertTarget = $("#sizingGuide__table-inch td");
      }

      $convertTarget.each(function(i) {

        // convert only when content is number and not null otherwise it's not null safe
        if ( (!isNaN(this.innerHTML)) && (this.innerHTML !== null) ) {
          cmValue = this.innerHTML;
          inchValue = Math.round(cmValue/2.54 * 4) / 4;
          $(this).contents().filter(function() {
            return this.nodeType == 3;
          })[0].nodeValue = inchValue;
        }

      });

      // move title
      var $h4Title = $("#sizingGuide__info").find("h4");
      $h4Title.first().appendTo($("#sizingGuide__content--guide-title"));
      $h4Title.eq(1).appendTo($("#sizingGuide__content--measure-title"));

      // insert img
      var $sizingEl = $(".sizing-guide__table").find("a"),
          sizingImgUrl = $sizingEl.attr("href"),
          sizingImg;
      if ( sizingImgUrl ) {
        $sizingEl.css("display", "none");
      }

    } else {
      //$(".open-size-guide").addClass("is-hidden");
    }

    // switch tabs: sizing table and measurement
    $("#sizingGuide").find(".sizing-guide__head").on('click', function(e) {
      e.preventDefault();

      var $guide_head = $(this);
      if ( !$guide_head.hasClass("active") ) {
        $guide_head.addClass('active');
        $guide_head.siblings().removeClass('active');

        var content_id = $(this).attr("href");
        $(".sizing-guide__content").not(content_id).css("display", "none");
        $(content_id).fadeIn();
      }
    });
    // switch tabs: cm and inches
    $("#sizingGuide").find(".sizing-guide__unit").on('click', function(e) {
      e.preventDefault();

      var $guide_head;

      if($(this).attr('id') == 'sizingGuide__info-cm--measure' || $(this).attr('id') == 'sizingGuide__info-cm') {
        $guide_head = $('#sizingGuide__info-cm--measure, #sizingGuide__info-cm');
        $measure_nums = $('#sizingGuide__content--measure .size-numbers .unit-cm');
      }
      else {
        $guide_head = $('#sizingGuide__info-inch--measure, #sizingGuide__info-inch');
        $measure_nums = $('#sizingGuide__content--measure .size-numbers .unit-inch');
      }

      // Label
      if ( !$guide_head.hasClass("active") ) {
        $guide_head.addClass('active');
        $guide_head.siblings().removeClass('active');
      }

      // Measurements
      if ( !$measure_nums.hasClass("active") ) {
        $measure_nums.addClass('active');
        $measure_nums.siblings().removeClass('active');
      }

      // Size Chart
      var content_id = $(this).attr("href");
      $(".sizing-guide__table").not(content_id).css("display", "none");
      $(content_id).fadeIn();

    });


    /********************************
    Measurements Tab
    *********************************/
    var xsPos = 0,
        sPos = 0,
        mPos = 0,
        lPos = 0,
        xlPos = 0,
        xxlPos = 0,
        smPos = 0,
        lxlPos = 0,
        pos28 = 0,
        pos30 = 0,
        pos31 = 0,
        pos32 = 0,
        pos33 = 0,
        pos34 = 0,
        pos36 = 0,
        measureClass = '',
        sizeClass = '',
        cmValue = 0,
        inchValue = 0,
        tabMaxHeight = 0,
        elPantSizePos = 0,
        el;

    // Sizes Switch
    $('#sizingGuide__table-cm table tr:first-child th:not(:first-child)').each(function(){
      el = $(this);
      sizeClass = el.text().toLowerCase().replace('/', '-');
      $('<li />', {
        'text'    : el.text(),
        'class'   : 'size-'+sizeClass
      }).appendTo('#sizingGuide__content--measure .sizes-switch ul');
      if(el.text() == 'XS'){
        xsPos = el.index() + 1;
      }
      else if(el.text() == 'S'){
        sPos = el.index() + 1;
      }
      else if(el.text() == 'M'){
        mPos = el.index() + 1;
      }
      else if(el.text() == 'L'){
        lPos = el.index() + 1;
      }
      else if(el.text() == 'XL'){
        xlPos = el.index() + 1;
      }
      else if(el.text() == 'XXL'){
        xxlPos = el.index() + 1;
      }
      else if(el.text() == 'S/M'){
        smPos = el.index() + 1;
      }
      else if(el.text() == 'L/XL'){
        lxlPos = el.index() + 1;
      }
      else if(el.text() == '28'){
        pos28 = el.index() + 1;
      }
      else if(el.text() == '30'){
        pos30 = el.index() + 1;
      }
      else if(el.text() == '31'){
        pos31 = el.index() + 1;
      }
      else if(el.text() == '32'){
        pos32 = el.index() + 1;
      }
      else if(el.text() == '33'){
        pos33 = el.index() + 1;
      }
      else if(el.text() == '34'){
        pos34 = el.index() + 1;
      }
      else if(el.text() == '36'){
        pos36 = el.index() + 1;
      }
    });

    // Click Event
    $('#sizingGuide__content--measure .sizes-switch li').on('click', function(){
      if(!$(this).hasClass('active')){
        var elClass = $(this).attr('class');
        $(this).addClass('active');
        $(this).siblings().removeClass('active');

        $('#sizingGuide__content--measure .size-numbers .'+elClass).addClass('active');
        $('#sizingGuide__content--measure .size-numbers .'+elClass).siblings().removeClass('active');

        if($('#ps-conversion').length) {

          if(elClass == 'size-xs'){
            elPantSizePos = xsPos;
          }
          else if(elClass == 'size-s'){
            elPantSizePos = sPos;
          }
          else if(elClass == 'size-m'){
            elPantSizePos = mPos;
          }
          else if(elClass == 'size-l'){
            elPantSizePos = lPos;
          }
          else if(elClass == 'size-xl'){
            elPantSizePos = xlPos;
          }
          else if(elClass == 'size-xxl'){
            elPantSizePos = xxlPos;
          }

          $('#ps-conversion').text($('#sizingGuide__table-cm table tr:last-child td:nth-child('+elPantSizePos+')').text());

        }
      }
    });


    // Pant Size Conversion
    $('#sizingGuide__table-cm table td').each(function(){
      el = $(this);
      if(el.text() == 'Pant Size' || el.text() == 'US Size'){
        $('#ps-conversion').text($(this).parent().children('td:nth-child('+mPos+')').text());
      }
    });

    // Size Numbers - CM/Inch
    if($("#sizingGuide__content--guide.product-pant").length || $("#sizingGuide__content--guide.product-kid").length) {
      var $sizeNumTarget = $("#sizingGuide__table-cm table tr:not(:first-child):not(:last-child)");
    }
    else {
      var $sizeNumTarget = $("#sizingGuide__table-cm table tr:not(:first-child)");
    }

    $sizeNumTarget.each(function(){
      var $el = $(this);

      $el.children('td').each(function(i){
        if(i == 0){
          measureClass = $(this).text().toLowerCase().replace(' ', '-');
          $('<div />', {
            'class'   : measureClass
          }).appendTo('#sizingGuide__content--measure .size-numbers');
          $('<div />', {
            'class'   : 'unit-cm'
          }).appendTo('#sizingGuide__content--measure .size-numbers div[class="'+measureClass+'"]');
          $('<div />', {
            'class'   : 'unit-inch'
          }).appendTo('#sizingGuide__content--measure .size-numbers div[class="'+measureClass+'"]');
        }
        else{
          if(xsPos == i + 1){
            sizeClass = 'xs';
          }
          else if(sPos == i + 1){
            sizeClass = 's';
          }
          else if(mPos == i + 1){
            sizeClass = 'm';
          }
          else if(lPos == i + 1){
            sizeClass = 'l';
          }
          else if(xlPos == i + 1){
            sizeClass = 'xl';
          }
          else if(xxlPos == i + 1){
            sizeClass = 'xxl';
          }
          else if(smPos == i + 1){
            sizeClass = 's-m';
          }
          else if(lxlPos == i + 1){
            sizeClass = 'l-xl';
          }
          else if(pos28 == i + 1){
            sizeClass = '28';
          }
          else if(pos30 == i + 1){
            sizeClass = '30';
          }
          else if(pos31 == i + 1){
            sizeClass = '31';
          }
          else if(pos32 == i + 1){
            sizeClass = '32';
          }
          else if(pos33 == i + 1){
            sizeClass = '33';
          }
          else if(pos34 == i + 1){
            sizeClass = '34';
          }
          else if(pos36 == i + 1){
            sizeClass = '36';
          }

          // convert only when content is number and not null otherwise it's not null safe
          if ( (!isNaN(this.innerHTML)) && (this.innerHTML !== null) ) {
            cmValue = this.innerHTML;
            inchValue = Math.round(cmValue/2.54 * 4) / 4;
          }

          $('<div />', {
            'class'   : 'size-'+sizeClass,
            'text'    : $(this).text()+'cm'
          }).appendTo('#sizingGuide__content--measure .size-numbers div[class="'+measureClass+'"] .unit-cm');

          $('<div />', {
            'class'   : 'size-'+sizeClass,
            'text'    : inchValue+'"'
          }).appendTo('#sizingGuide__content--measure .size-numbers div[class="'+measureClass+'"] .unit-inch');

        }
      });
    });

    // Tab Height
    function calculateTabMaxHeight() {
      tabMaxHeight = 0;
      $('.sizing-guide > .sizing-guide__content').css('min-height', '');

      $('.sizing-guide > .sizing-guide__content').each(function(){
        el = $(this);
        if(el.actual( 'height' ) >= tabMaxHeight){
          tabMaxHeight = el.actual( 'height' );
        }
      });
      $('.sizing-guide > .sizing-guide__content').css('min-height', tabMaxHeight);
    }
    var runFunc;
    $(window).on('load resize', function(){
      clearTimeout(runFunc);
      runFunc = setTimeout(calculateTabMaxHeight, 100);
    });



    // First Tab - Active
    $('.sizing-guide .sizing-guide__head:first-child, .sizing-guide > div.sizing-guide__content:nth-child(2)').addClass('active');

    // Default Active Size
    if($('#sizingGuide__content--measure .sizes-switch .size-m').length) {
      $('#sizingGuide__content--measure .sizes-switch .size-m, #sizingGuide__content--measure .size-numbers .size-m').addClass('active');
    }
    else if($('#sizingGuide__content--measure .sizes-switch .size-s').length) {
      $('#sizingGuide__content--measure .sizes-switch .size-s, #sizingGuide__content--measure .size-numbers .size-s').addClass('active');
    }
    else if($('#sizingGuide__content--measure .sizes-switch .size-s-m').length) {
      $('#sizingGuide__content--measure .sizes-switch .size-s-m, #sizingGuide__content--measure .size-numbers .size-s-m').addClass('active');
    }
    else {
      $('#sizingGuide__content--measure .sizes-switch .size-31, #sizingGuide__content--measure .size-numbers .size-31').addClass('active');
    }
    $('#sizingGuide__content--measure .size-numbers .unit-cm').addClass('active');

  }
})();

/*============================================================================
  Header collapse on scroll
==============================================================================*/
timber.rc_product_info_sticky = (function () {

  // max width is 323px in CSS
  if ( $(".supports-no-touch").length && $(".template-product").length ) {
    var elemWidth = $(".js-product-right-width").width(),
        $target = $(".product-right-position--sticky");
    $target.width(elemWidth);

    $(window).smartresize(function() {
      elemWidth = $(".js-product-right-width").width(),
      $target = $(".product-right-position--sticky");
      $target.width(elemWidth);
    });
  }

})();

/*============================================================================
  Product search overlay
==============================================================================*/
timber.rc_product_search = (function () {

  if ( $('.overlay--search').length ) {
    var $searchOpen = $(".js-open-search"),
        $searchClose = $(".js-close-search"),
        $search = $(".overlay--search"),
        $body = $("body"),
        $searchField = $('#search-field');

    $searchOpen.on('click', function(event) {
      $search.prepareTransition().removeClass('is-hidden');
      $body.addClass("no-scroll");
      $searchField.focus();
      $('.overlay-search').removeClass('is-hidden');
    });

    $searchClose.on('click', function(event) {
      $search.prepareTransition().addClass('is-hidden');
      $body.removeClass("no-scroll");
      $('.overlay-search').addClass('is-hidden');
      $('.search--results').addClass('is-hidden');
      $searchField.val('');
    });

    $('.overlay-search').on('click', function(event) {
      $search.prepareTransition().addClass('is-hidden');
      $body.removeClass("no-scroll");
      $('.overlay-search').addClass('is-hidden');
      $('.search--results').addClass('is-hidden');
      $searchField.val('');
    });

  }

})();

/*============================================================================
  Ajax cart: Store pickup
==============================================================================*/
timber.rc_ajaxcart_storepickup = (function () {

  // var $app;
  // $(document).ajaxComplete(function(event, xhr, settings) {
  //   $app = $("#storePickupApp");
  //   $app.find(".method").on('click', function(e) {
  //   });
  //   setTimeout(function() {
  //     console.log($("#methods"));
  //   }, 5000);
  // });
})();

/*============================================================================
  Banner notification
==============================================================================*/
timber.rc_banner = (function () {
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*1000)); // seconds to milliseconds
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/;";
  }
  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  /*================ frequency options in backend ================*/
  // 1 Day: 86400
  // 1 Week: 604800
  // 1 Month: 2592000
  // Disable: 0

  var frequency = $('.js-sitewide-notice').data('frequency');
  // if not visited && not disabled
  if ( !getCookie('rc_site_visited') && (frequency !== 0) ) {
    setCookie('rc_site_visited', true, frequency);
    $('.js-sitewide-notice').css({display: 'block'});
  }
  // keep promotion bar until user clicks close button && not disabled
  if ( !getCookie('rc_banner_closed') && (frequency !== 0) ) {
    $('.js-sitewide-notice').css({display: 'block'});
  }
  $('.js-sitewide-notice__close').on('click', function() {
    // TODO:prepareTransition cannot refer to $ only on cart page
    if ( $(".template-cart").length ) {
      jQuery('.js-sitewide-notice').slideUp(800, 'easeOutExpo');
    } else {
      $('.js-sitewide-notice').slideUp(800, 'easeOutExpo');
    }

    $('#PageContainer').removeClass('notification-exists');

    setCookie('rc_banner_closed', true, frequency);
  });

})();

/*============================================================================
  Header collapse on scroll
  - header collapse
  - banner position calc
==============================================================================*/
timber.rc_scroll = (function () {

  //if ( $(".supports-no-touch").length ) {
    var scroll = window.requestAnimationFrame ||
                 window.webkitRequestAnimationFrame ||
                 window.mozRequestAnimationFrame ||
                 window.msRequestAnimationFrame ||
                 window.oRequestAnimationFrame ||
                 // IE Fallback, you can even fallback to onscroll
                 function(callback) { window.setTimeout(callback, 1000/60); };

    var distanceY = 0,
        shrinkOn = 200,
        lastPosition = -1,
        $body = $("body"),
        // below: for not to cover banner notification
        $PageContainer = $("#PageContainer"),
        $banner = $(".js-sitewide-notice"),
        banner = $banner[0],
        bannerPropDisplay,
        bannerBottom,

        isHome = $(".template-index").length;

    function loop(){

      distanceY = window.pageYOffset || document.documentElement.scrollTop;

      // prevent calculation if not scrolled
      if (lastPosition === distanceY) {
          scroll(loop);
          return false;
      } else {
        lastPosition = distanceY;
      }

      // scroll collapse only on desktop: see .scroll class in scss
      if ( $(".supports-no-touch").length ) {
        if (distanceY > shrinkOn) {
          $body.addClass("scroll");
        } else {
          if ($body.hasClass("scroll")) {
            $body.removeClass("scroll");
          }
        }
      }


      // bannerPropDisplay = $banner.css("display");
      // // need calculation if banner displayed
      // if (bannerPropDisplay === "block") {

      //   bannerBottom = banner.getBoundingClientRect().bottom;
      //   // when banner goes away from vp, fix header
      //   if (bannerBottom < 1) {
      //     $PageContainer.removeClass("notification-exists");

      //   } else {

      //     if (!$PageContainer.hasClass("notification-exists")) {
      //       $PageContainer.addClass("notification-exists");
      //     }
      //   }
      // } else {
      //   $PageContainer.removeClass("notification-exists");
      // }


      scroll(loop);

    }

    loop();

  //}

})();


timber.loaded = (function () {

  $(window).on('load', function() {
    timber.cache.$body.removeClass("loading").addClass("loaded");

    // // Increase content height to stay footer bottom
    // var windowH = window.innerHeight,
    //     bodyH = $cachedbody.outerHeight(true);

    // if ( windowH > bodyH ) {
    //   var $main = $(".main-content"),
    //       mainH = $main.outerHeight(true),
    //       diff = windowH - bodyH;
    //   $main.css({
    //     'min-height': mainH + diff
    //   });
    // }

    if($('#sizingGuide').length) {
      $('.open-size-guide').addClass('active');
    }

  });

})();

     /*============================================================================
        New Menu Desktop
      ==============================================================================*/

      $subNavTrigger = $('.sub-nav-trigger');
      // $subNavMen = $('.subnav-men');
      // $subNavTriggerWomen = $('.sub-nav-trigger-women');
      // $subNavWomen = $('.subnav-women');
      $subNavTriggerSupport = $('.sub-nav-trigger-support');
      $subNavSupport = $('.subnav-support');
      $jsopenMenuTouch = $('.touch-trigger');
      $jsopenMenuLink = $('.touch-link');

      $jsopenMenuTouch.hover(function() {
        if ($('body').hasClass('show-preview')) {
          $('body').removeClass('show-preview');
        }

        $('.touch-trigger').removeClass('active');
        $(this).addClass('active');
        $('[data-subnav]').removeClass('active');
        $('[data-subnav="' + $(this).data('subnav-trigger')  + '"]').addClass('active');
      });

      $('.site-nav--new').hover(function(e) {
        $(this).find('.test-wrapper').addClass('active');
        $('.overlay').removeClass('is-hidden');

        // which subnav item is closest to mouse?
        // open that one by default so this weird
        // functionality is not so jarring
        var navItems = [];
        $('[data-subnav-trigger]').each(function(index) {
          navItems[Math.floor(Math.sqrt(Math.pow(e.pageX - ($(this).offset().left + ($(this).width() / 2)), 2) + Math.pow(e.pageY - ($(this).offset().top + ($(this).height() / 2)), 2)))] = $(this).data('subnav-trigger')
        })

        navItems.sort(function (a, b) {
          return a - b;
        });

        $('[data-subnav="' + navItems[0] + '"]').addClass('active');
        $('[data-subnav-trigger="' + navItems[0] + '"]').addClass('active');
      }, function() {
        $(this).find('.test-wrapper').removeClass('active');
        $('.overlay').addClass('is-hidden');
        $('[data-subnav]').removeClass('active');
        $('.touch-trigger').removeClass('active');
      });

      if ('ontouchstart' in window) {
        $jsopenMenuLink.click(function(e) {
          e.preventDefault();
        });
      }

      window.addEventListener('touchstart', function() {

        $jsopenMenuTouch.on('click', function() {
            $jsopenMenuTouch.removeClass('subnav-active-touch');
            $(this).addClass('subnav-active-touch');
            $('.overlay').removeClass('is-hidden');
        });
        $('.overlay').on('click', function() {
          $jsopenMenuTouch.removeClass('subnav-active-touch');
          $(this).addClass('is-hidden');
        });
      });


      /*============================================================================
        New Menu Mobile
      ==============================================================================*/
      $('.js-open-secondary-nav').on('click', function() {
        $('.subnav-' + $(this).data('nav') + '-mobile').slideToggle(200);
        $(this).toggleClass('menu-toggled');
        $(this).find('.icon-animatable').toggleClass("plus");
      });

       /*============================================================================
        Collection Hero Info Expand
      ==============================================================================*/

      $infoTrigger = $('.info-trigger');
      $infoDescription = $('.collection-description');
      $infoHeroContainer = $('.collection-hero-wrap');

      $infoTrigger.click(function() {
        $infoHeroContainer.toggleClass('collection-hero-wrap__extended');
        $(this).find($plusicon).toggleClass("plus");
      });

      $infoTriggerFabric = $('.collection-hero-wrap');
      $infoDescriptionFabric = $('.collection-info-fabric');

      $infoTriggerFabric.click(function() {
        $('body').toggleClass('show-fabric');
        // $infoDescriptionFabric.slideToggle();
        $(this).find('.icon-animatable').toggleClass("plus");
      });

      // $infoTrigger.click(function() {
      //   $infoDescription.slideToggle();
      //   $(this).find($plusicon).toggleClass("plus");
      //   console.log('test-new');
      // });

/*============================================================================
  Newsletter Popup
==============================================================================*/

timber.newsletter_popup = (function () {

  /*================ Newsletter overlay ================*/
  if ( $('.overlay--newsletter').length ) {
    var $popupClose = $(".js-close-newsletter"),
        $popupOpen = $(".js-open-newsletter"),
        $overlay = $(".overlay--newsletter"),
        $popupContent = $(".newsletter-popup__content"),
        $body = $("body");


    $popupClose.on('click', function(event) {
      $overlay.prepareTransition().addClass('is-hidden');
      $body.removeClass("no-scroll");
    });

    $popupOpen.on('click', function() {
      $body.addClass('no-scroll');
      $overlay.prepareTransition().removeClass('is-hidden');
    });

    // Lock scrolling on mobile
    $popupContent.on('touchmove', function () {
      return false;
    });

    $overlay.on('click', function(e) {
      if(e.target !== e.currentTarget) {
        return;
      }
      $overlay.prepareTransition().addClass('is-hidden');
      $body.removeClass("no-scroll");
    });
  }

})();

/*============================================================================
  Shop link popup based on user's country
==============================================================================*/
timber.rc_shoplink_popup = (function () {

  var $shoplinkOverlay = $('.overlay--shoplink-popup');

  /*================ location check ================*/
  var us_link = $('body').data('us-link');
  //var fake_loc = 'US'; //TEST

  // console.log('testing location');

  if ( $shoplinkOverlay.length > 0 ) {

    var siteCountry = $shoplinkOverlay.data('site-country');
    var siteLink = window.location.href;
    var updateLink = siteLink.replace(/shop/, "ca");
    var updateUSLink = siteLink.replace(/ca/, "shop");
    //var fake_loc = 'US'; //TEST

    // set endpoint and your access key
    // var ip = '23.16.204.87'
    var access_key = 'f880653a1d4ba885856045ec468dc7dc';

    fetch('https://api.ipstack.com/check?access_key=' + access_key)
      .then(response => response.json())
      .then(location => {
        // console.log(location);
            // console.log('user location: ' + location.country_code);
            // console.log('site for : ' + siteCountry);
            // console.log(siteLink);
            // console.log(updateLink);

        if (siteCountry !== 'ca' ) {
          $('body').addClass('not-canada');
        }
        if (location.country_code === 'CA' && siteCountry !== 'ca') {
          // CA customer lands on Non-CA site
          $shoplinkOverlay.prepareTransition().removeClass('is-hidden');
          $shoplinkOverlay.find('a.shoplink-popup__link-ca').each( function() {
            $(this).attr('href', updateLink);
          });
        } else if (location.country_code === 'JP') {
          // JP customer lands on either site
          $shoplinkOverlay.prepareTransition().removeClass('is-hidden');
        } else if (location.country_code !== 'CA' && siteCountry === 'ca') {
          // Non-CA customer lands on CA site
          $shoplinkOverlay.prepareTransition().removeClass('is-hidden');
          $shoplinkOverlay.find('a.shoplink-popup__link-us').each( function() {
            $(this).attr('href', updateUSLink);
          });
        }
      });


    // $.ajax({
    //   url: 'https://api.ipstack.com/check?access_key=' + access_key,
    //   type: 'POST',
    //   dataType: 'jsonp',
    //   crossDomain: true,
    //   success: function (location) {
    //       console.log(location);
    //       console.log('user location: ' + location.country_code);
    //       console.log('site for : ' + siteCountry);
    //       console.log(siteLink);
    //       console.log(updateLink);

    //       if (siteCountry !== 'ca' ) {
    //         $('body').addClass('not-canada');
    //       }
    //       if (location.country_code === 'CA' && siteCountry !== 'ca') {
    //         // CA customer lands on Non-CA site
    //         $shoplinkOverlay.prepareTransition().removeClass('is-hidden');
    //         $shoplinkOverlay.find('a').each( function() {
    //           $(this).attr('href', updateLink);
    //         });
    //       } else if (location.country_code !== 'CA' && siteCountry === 'ca') {
    //         // Non-CA customer lands on CA site
    //         $shoplinkOverlay.prepareTransition().removeClass('is-hidden');
    //         $shoplinkOverlay.find('a').each( function() {
    //           $(this).attr('href', updateUSLink);
    //         });
    //       }
    //     },
    //   error:function(response){
    //     console.log(response.error);
    //     console.log(response.error.code);
    //     console.log("Failed to get user location.");
    //   }
    // })
    // .then(
    //     function (location) {
    //       console.log(location);
    //       console.log('user location: ' + location.country_code);
    //       console.log('site for : ' + siteCountry);
    //       console.log(siteLink);
    //       console.log(updateLink);

    //       if (siteCountry !== 'ca' ) {
    //         $('body').addClass('not-canada');
    //       }
    //       if (location.country_code === 'CA' && siteCountry !== 'ca') {
    //         // CA customer lands on Non-CA site
    //         $shoplinkOverlay.prepareTransition().removeClass('is-hidden');
    //         $shoplinkOverlay.find('a').each( function() {
    //           $(this).attr('href', updateLink);
    //         });
    //       } else if (location.country_code !== 'CA' && siteCountry === 'ca') {
    //         // Non-CA customer lands on CA site
    //         $shoplinkOverlay.prepareTransition().removeClass('is-hidden');
    //         $shoplinkOverlay.find('a').each( function() {
    //           $(this).attr('href', updateUSLink);
    //         });
    //       }
    //     },
    //     function () {
    //       // console.log(location);
    //       console.log('fail to get user location');
    //     }
    // )
  }

  /*================ overlay ================*/
  if ( $shoplinkOverlay.length > 0 ) {
    var $shoplinkClose = $(".js-close-shoplink-popup"),
        $popupContent = $(".shoplink-popup__content"),
        $body = $("body");

    $shoplinkClose.on('click', function(event) {
      $shoplinkOverlay.prepareTransition().addClass('is-hidden');
      $body.removeClass("no-scroll");
    });
    // Lock scrolling on mobile
    $popupContent.on('touchmove', function () {
      return false;
    });

    $shoplinkOverlay.on('click', function(e) {
      if(e.target !== e.currentTarget) {
        return;
      }
      $shoplinkOverlay.prepareTransition().addClass('is-hidden');
      $body.removeClass("no-scroll");
    });
  }


  // function searchTabs() {
  //   var $tab = $('.search-tab'),
  //   $tabContent = $('.product-wrap'),
  //   $womens = document.getElementsByClassName('womens'),
  //   $mens = document.getElementsByClassName('mens');

  //   // console.log($womens);

  //   // console.log($mens);

  //   if($womens.length > 0 && $mens.length > 0) {
  //     $('.search-tabs').show();
  //   } else {
  //     $('.search-tabs').hide();
  //   }

  //   $tab.click(function() {
  //     var $dataTab = $(this).attr('data-tab');

  //     // console.log($dataTab);
  //     $tab.removeClass('active-tab');
  //     $(this).addClass('active-tab');

  //     if($dataTab === 'all') {
  //       $tabContent.show();
  //     } else {
  //       $tabContent.each(function() {
  //         if ( $(this).hasClass($dataTab) ) {
  //           $(this).show();
  //         } else {
  //           $(this).hide();
  //         }
  //       });
  //     }

  //   })
  // }
  // searchTabs();

})();


// Initialize Timber's JS on docready
$(timber.init);


// CART PREVIEW
function closePreview() {
  jQuery('.cart-preview__close').click(function() {
    $('body').removeClass('show-preview');
    $('.overlay').addClass('is-hidden');
    // console.log('close preview');
  });
}
closePreview();

function showPreview() {

  if($('body').hasClass('template-cart')) {
    //do nothing
  } else {
    var userDeviceWidth = $(window).width();
    jQuery('.preview-wrapper').hover(
      function() {
        if ( userDeviceWidth > 1024 ) {
          $('.cart-preview').addClass('mouseover');
          $('.overlay').removeClass('is-hidden');
          $('body').addClass('show-preview');
        }
      }, function() {
        if (userDeviceWidth > 1024) {
          $('.cart-preview').removeClass('mouseover');
          if ($('body').hasClass('cart-item-added')) {
            $('body').removeClass('show-preview cart-item-added');
            $('.overlay').addClass('is-hidden');
          } else {
            $('body').removeClass('show-preview');
            $('.overlay').addClass('is-hidden');
          }
        }
      }
    );

    jQuery('.btn--drawer-open-right').click(function(e) {
      if ( userDeviceWidth <= 1024 ) {
        if ( $('body').hasClass('show-preview') ) {
          e.preventDefault();
          $('body').removeClass('show-preview');
        } else {
          e.preventDefault();
          $('body').addClass('show-preview');
        }
      }
    });

   // window.addEventListener('touchstart', function() {
   //  jQuery('.btn--drawer-open-right').click(function(e) {
   //    if ( $('body').hasClass('show-preview') ) {
   //      e.preventDefault();
   //      $('body').removeClass('show-preview');
   //    } else {
   //      e.preventDefault();
   //      $('body').addClass('show-preview');
   //    }

   //  });
   // });
  }


}
showPreview();


//PREDICTIVE SEARCH

// import PredictiveSearch from "@shopify/theme-predictive-search";

// var predictiveSearch = new PredictiveSearch({
//   search_as_you_type: {
//     types: [PredictiveSearch.TYPES.PRODUCT],
//     limit: 4,
//     unavailable_products: "bury"
//   }
// });


// // Set success event listener
// predictiveSearch.on("success", suggestions => {
//   const productSuggestions = suggestions.resources.results.products;

//   if (productSuggestions.length > 0) {
//     var firstProductSuggestion = productSuggestions[0];

//     alert(`The title of the first product suggestion is: ${
//           firstProductSuggestion.title}`
//     )
//   }
// });


// // Set error event listener
// predictiveSearch.on("error", error => {
//    console.error("Error message:", error.message);
// });


// // Send query
// predictiveSearch.query("The Calling");


// jQuery.getJSON("/search/suggest.json", {
//   s: "jacket",
//   resources: {
//     "types": ["product"],
//     "limit": 4,
//     "unavailable_products": "bury"
//   }
// }).done(function(response) {
//   var productSuggestions = response.resources.results.products;

//   if (productSuggestions.length > 0) {
//     var firstProductSuggestion = productSuggestions[0];

//     alert("The title of the first product suggestion is: " + firstProductSuggestion.title);
//   }
// });


//predictive search

function searchProducts() {

    var searchField = jQuery('#search-field').val();

    jQuery('#search-all-link').attr('href', '/search?type=product&q=' + searchField);

    searchShopUrl = '/search/suggest.json?s=' + searchField + '&resources[types][]=product&resources[limit]=4&resources[unavailable_products]=bury';
    // console.log(searchShopUrl);
    jQuery.getJSON(searchShopUrl, function(data) {

      // console.log(data['resources']['results']['products']);

        if (data['resources']['results']['products'].length > 0) {
          jQuery('.search--results').removeClass('is-hidden');
        } else {
          jQuery('.search--results').addClass('is-hidden');
        }

      var output = '<ul>';

      jQuery.each(data['resources']['results']['products'], function(key, val) {

        output += '<li><a href="' + val.url + '">';
        output += '<img src="' + val.image + '" alt="' + val.title + '">';
        output += '<h2 class="adidas-title-text">' + val.title + '</h2>';
        output += '</li></a>';

      });
      // });
      output += '</ul>';

      jQuery('.search--results-ajax').html(output);

    }); //get JSON
  // });
}
// searchProducts();

//setup before functions
var typingTimer;                //timer identifier
var doneTypingInterval = 300;  //time in ms, 5 second for example
var $input = jQuery('#search-field');

// //on keyup, start the countdown
jQuery(document).on('keyup', '#search-field', function () {
  clearTimeout(typingTimer);
  typingTimer = setTimeout(searchProducts, doneTypingInterval);

  //if delete all inputs hide search results
  var searchField = jQuery('#search-field').val();
  // console.log(searchField);
  if (searchField === '') {
    jQuery('.search--results').addClass('is-hidden');
  }
});

// //on keydown, clear the countdown
jQuery(document).on('keydown', '#search-field', function () {
  clearTimeout(typingTimer);
});

//custom select

if (timber.getWindowWidth() > 10) {

var searchTerm = (window.location.search);

var x, i, j, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("custom-select");
for (i = 0; i < x.length; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < selElmnt.length; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.setAttribute("data-value", selElmnt.options[j].value);


    if( searchTerm.includes('ascending') ) {
      c.classList.remove('current-select');
      if(selElmnt.options[j].value === 'price-ascending') {
        c.classList.add('current-select');
      }
    } else if (searchTerm.includes('descending')) {
      c.classList.remove('current-select');
      if(selElmnt.options[j].value === 'price-descending') {
        c.classList.add('current-select');
      }
    }
    if(searchTerm === '' || searchTerm.includes('manual')) {
      if(selElmnt.options[j].value === 'manual') {
        c.classList.add('current-select');
      }
    }

    c.addEventListener("click", function(e) {
        /* When an item is clicked, update the original select box,
        and the selected item: */

        var y, i, k, s, h;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        h = this.parentNode.previousSibling;
        for (i = 0; i < s.length; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("current-select");
            for (k = 0; k < y.length; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected current-select");
            // console.log(selectedColours, selectedFits, selectedSizes);

            var sortedBy = this.getAttribute('data-value');
            document.getElementById('product-grid-wrap').classList.add('loading');

            // console.log(sortedBy);
            //check filters

var currentHash = window.location.hash;
var allHash = currentHash.slice(1);
var hashArr = allHash.split(',');
selectedColours = [];
selectedFits = [];
selectedSizes = [];

// console.log(selectedSizes);
// console.log(selectedColours);
// console.log(selectedFits);

if(currentHash) {
  // console.log(currentHash);
//   console.log(allHash);
//   console.log(hashArr);
  var $itemInput = $(".product-filter__item").find("input"),
  itemInputValue;

//   $itemInput.each(function() {
//   itemInputValue = $(this).attr("value");
//   console.log(itemInputValue);

//   // if ( hashArr.indexOf(itemInputValue) > -1 ) {
//   //   $(this).prop('checked', true).addClass("is-checked");
//   // }
// });


  for(var f = 0; f < hashArr.length; f++) {
    if(hashArr[f].includes('colour')) {
      selectedColours.push(hashArr[f]);
    }
    else if(hashArr[f].includes('fit')) {
      selectedFits.push(hashArr[f]);
    }
    else {
      var hashSize = hashArr[f].replace(/%20/g, " ");
      selectedSizes.push(hashSize);
    }
  }

  getProducts(selectedColours, selectedFits, selectedSizes, sortedBy);

  // console.log(selectedColours);
  // console.log(selectedFits);
  // console.log(selectedSizes);
  // window.history.pushState(sortedBy, sortedBy, currentHash);
}
else {
  getProducts(selectedColours, selectedFits, selectedSizes, sortedBy);
  // window.history.pushState(sortedBy, sortedBy, '?sort_by=' + sortedBy);
}
$("body, html").animate({
  scrollTop: $("#product-grid-wrap").position().top - 70
});
            // getProducts(selectedColours, selectedFits, selectedSizes);
            // checkFilters();

            // window.location = '?sort_by=' + this.getAttribute('data-value');
            break;
          }
        }
        h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
    e.preventDefault();
        // console.log('select clicked');
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");

    // console.log('click select');


  });
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x, y, i, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  for (i = 0; i < y.length; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < x.length; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);

// document.querySelector('#sort-by').addEventListener('change', function() {
//   console.log('sort by');
//   const urlSearchParams = new URLSearchParams(window.location.search);

//   urlSearchParams.set(this.name, this.value);

//   window.location = `?${urlSearchParams}`;
// });

}

if (timber.getWindowWidth() <= 1024) {
  jQuery('#sort-by > option:first').hide();
}

function getProducts(selectedColours, selectedFits, selectedSizes, sortedBy) {
  var collectionId = jQuery('#product-grid-wrap').data('id');
  var collectionHandle = jQuery('#product-grid-wrap').data('handle');
  var restURL = '/collections/' + collectionHandle + '/products.json';
  var pageLimit;
  var prodUrls = [];
  var products = [];
  var type;
  var allProducts = [];
  // console.log(restURL);

  // console.log(allProducts);

  var collectionType = jQuery('#product-grid-wrap').data('tags');
  if(collectionType) {
    type = collectionType;
    // console.log(type);
  }

  fetch(restURL) // Call the fetch function passing the url of the API as a parameter
  .then(function(resp) {
    ///need to get total number of products/pages to limit requests. May need to connect to storefront api
    var totalPages = 10;
    for (i = 1; i <= totalPages; i++) {
      let url = restURL + '?page=' + i;
      prodUrls.push(url);
    }

    Promise.all(prodUrls.map(url =>
      fetch(url)
        .then(function(response)  {
          return response.json();
        })
        .catch(error => console.log('There was a problem!', error))
    ))
    .then(data => {

      for(var j = 0; j < data.length; j++) {
        // console.log(data[j]);
          products = products.concat(data[j].products);
      }



      if(type) {
        for(var i = 0; i < products.length; i++ ) {
          var thisProduct = products[i];

          if ( thisProduct.tags.indexOf(type) !== -1 ) {
            allProducts.push(thisProduct)
          }
        }
        // filterType(allProducts, type);
      } else {
        // not sure yet.
        allProducts = products;
      }

      // console.log(selectedSizes);
      // console.log(allProducts);
      filterProducts(selectedColours, selectedFits, selectedSizes, sortedBy, allProducts);
      // document.getElementById('product-grid-wrap').classList.remove('loading');
      // outputProducts(allProducts);
      // console.log(products);
    })

  })
  .catch(function() {
      // This is where you run code if the server returns any errors
      // console.log('error');
  });
}


function filterProducts(selectedColours, selectedFits, selectedSizes, sortedBy, allProducts) {
  // console.log('selected sizes:' + selectedSizes);
  var filteredProducts = [];
  var rcProducts = [];
  // console.log(allProducts);

    for(var i = 0; i < allProducts.length; i++ ) {
      var thisProduct = allProducts[i];

      var hasColour = '';
      var hasFit = '';
      var hasSize = '';
      var hasVariant = '';

      if(selectedColours.length > 0) {
        for(var j = 0; j < selectedColours.length; j++ ) {
          // console.log(selectedColours[j]);
          if(hasColour === true) {
            break;
          }
          if ( thisProduct.tags.indexOf(selectedColours[j]) !== -1 ) {
            hasColour = true;
          } else {
            hasColour = false;
          }
        }
      }
      // console.log(selectedSizes);

      if(selectedFits.length > 0) {
        for(var f = 0; f < selectedFits.length; f++ ) {
          // console.log(selectedFits[j]);
          if(hasFit === true) {
            break;
          }
          if ( thisProduct.tags.indexOf(selectedFits[f]) !== -1 ) {
            hasFit = true;
          } else {
            hasFit = false;
          }
        }
      }
      // console.log(selectedSizes);

      if(selectedSizes.length > 0) {
        for(var k = 0; k < selectedSizes.length; k++ ) {
          // console.log(selectedSizes[k]);
          if (hasSize === true ) {
            break;
          }

          for (var n = 0; n < thisProduct.variants.length; n++ ) {
            // console.log(thisProduct.variants[n].option1);
            if (hasVariant === true ) {
              break;
            }

            if(thisProduct.variants[n].option1 === selectedSizes[k] && thisProduct.variants[n].available === true) {
              hasSize = true;
              hasVariant = true;
              // console.log(thisProduct);
            } else {
              hasSize = false;
            }
          }
        }
      }

      // console.log(hasColour);
      // console.log(hasSize);

      if(hasColour !== false && hasFit !== false && hasSize !== false ) {
        if( filteredProducts.indexOf(thisProduct) === -1 ) {
          filteredProducts.push(thisProduct);
          // console.log('success');
        }
      }
      else {
        // console.log('nope');
        if(filteredProducts.indexOf(thisProduct) !== -1 ) {
          var index = filteredProducts.indexOf(thisProduct);
          filteredProducts.splice(index, 1);
        }
      }

    }
    rcProducts = filteredProducts;
    outputProducts(selectedColours, selectedFits, selectedSizes, sortedBy, rcProducts);
  // });
}
// filterProducts();

// function filterType(allProducts, type) {
//   var rcProducts = [];

//   for(var i = 0; i < allProducts.length; i++ ) {
//     var thisProduct = allProducts[i];

//     if ( thisProduct.tags.indexOf(type) !== -1 ) {
//       console.log(true);
//     } else {
//       console.log(false);
//     }
//   }
// }

function outputProducts(selectedColours, selectedFits, selectedSizes, sortedBy, rcProducts) {

  var searchTerm = (window.location.search);
  // console.log(sortedBy);

  if( rcProducts.length > 0 ) {

    if( searchTerm.includes('ascending') ) {
      // console.log('search ascending');
      rcProducts.sort(function(a, b) {
        return parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price);
      });
    } else if( sortedBy === 'price-ascending' ) {
      // console.log('search ascending');
      rcProducts.sort(function(a, b) {
        return parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price);
      });
    } else if (searchTerm.includes('descending') ) {
      // console.log('search descending');
      rcProducts.sort(function(a, b) {
        return parseFloat(b.variants[0].price) - parseFloat(a.variants[0].price);
      });
    }
    else if (sortedBy === 'price-descending' ) {
      // console.log('search descending');
      rcProducts.sort(function(a, b) {
        return parseFloat(b.variants[0].price) - parseFloat(a.variants[0].price);
      });
    }

    // var activeFilters = [];
    // activeFilters = selectedColours.concat(selectedSizes);

    // window.history.pushState({path: galleryUrl},'',galleryUrl);

    var output = '<div class="grid__item"><div class="grid-uniform u-mb">';
    jQuery.each(rcProducts, function(key, val) {

      var productTag;
      var allTags = val.tags;

      jQuery(allTags).each(function() {
        var value = this;
        if (value.substring(0, 13) === "colour-filter") {
          productTag = value.slice(14);
          // console.log(productTag);
        }
        else if (value.substring(0, 3) === "fit") {
          productTag = value.slice(4);
        }
      });

      var prodAvailable = false;

      for (var s = 0; s < val.variants.length; s++ ) {
        if (val.variants[s].available === true) {
          prodAvailable = true;
          // console.log(prodAvailable);
          break;
        }
      }


      var newProduct = false;
      var pYear = val.published_at.slice(0,4);
      var pMonth = val.published_at.slice(5,7);
      var pDay = val.published_at.slice(8,10);
      var pDate = pYear + pMonth + pDay;
      var d = new Date;
      var tDay = d.getDate().toString();
      var month = d.getMonth() + 1;
      var tMonth = month.toString();
      var tYear = d.getFullYear().toString();
      var currency = $('body').data('currency');

      if(tMonth < 10) {
        var todaysDate = tYear + '0' + tMonth + tDay;
      } else {
        var todaysDate = tYear + tMonth + tDay;
      }

      if(parseInt(todaysDate) - parseInt(pDate) < 30 ) {
        var newProduct = true;
        // console.log(newProduct);
      }
      // console.log(newProduct);

      output += '<div class="grid__item product-wrap large--one-third medium--one-half">';
      if(val.tags.indexOf('coming-soon') !== -1) {
        output += '<div class="product-status">Coming Soon</div>';
      } else if (prodAvailable === false) {
        output += '<div class="product-status">Sold Out</div>';
      } else if (val.variants[0].compare_at_price > val.variants[0].price ) {
        output += '<div class="product-status">On Sale</div>';
      } else if (newProduct === true) {
        output += '<div class="product-status">New</div>';
      }

      // output += '<div class="product-status">New</div>';
      output += '<a href="/products/' + val.handle + '"><picture><img src="' + val.images[0].src + '"></picture></a>';
      output += '<div class="quick--add__wrapper"><div class="product-info"><h3 class="product-title">';
      output += val.title;
      output += '</h3><h4 class="product-title-info">' + val.variants[0].option2 + '</h4>';
      output += '<h4 class="product-title-info product-title-price">$' + val.variants[0].price + ' ' + currency + '</h4>';
      output += '</div>';
      output += '<div class="product-sizes-wrapper"><h4 class="product-title-info">QUICK ADD</h4>';
      output += '<form id="AddToCartForm" action="/cart/add" method="post" enctype="multipart/form-data" data-id="' + val.id + '" class="form-vertical product-size-form">';

      if (val.variants[0].compare_at_price > val.variants[0].price ) {
        output += '<input type="hidden" id="_saleitem" name="properties[_saleitem]">';
      }

      output += '<div class="product-sizes product-size-form__sizes">';

      jQuery(val.variants).each(function() {

        var size = '';
        if (this.option1 === 'Extra Small') {
          size = 'XS';
        } else if (this.option1 === 'Small') {
          size = 'S';
        } else if (this.option1 === 'Medium') {
          size = 'M';
        } else if (this.option1 === 'Large') {
          size = 'L';
        } else if (this.option1 === 'Extra Large') {
          size = 'XL';
        } else if (this.option1 === 'Extra Extra Large') {
          size = 'XXL';
        } else if (this.option1 === 'XX Large') {
          size = 'XXL';
        } else {
          size = this.option1;
        }

        if(this.available === true) {
          output += '<label class="product-size-form__item is-available">';
          output += '<input class="product-size-input" type="radio" name="id" data-sku="';
          output += this.sku;
          output += '" value="';
          output += this.id;
          output += '" data-size="';
          output += this.title;
          output += '" data-id="';
          output += val.id + '">';
          output += '<span class="product-size">' + size + '</span></label>';
        } else {
          output += '<label class="product-size-form__item"><input disabled type="radio"><span class="product-size product-size--not-available">' + size + '</span></label>';
        }

      });

      output += '</div>';
      output += '<button id="AddToCart" type="submit" name="add"';
      output += 'class="btn product-size-form__submit ' + val.id + '"';
      output += '>Add to Cart</button>';
      output += '</form>';
      output += '</div>';
      output += '</div>';
      output +=  '</div>';

    });
    output += '</div></div>';
    jQuery('#product-grid-wrap').html(output);
  } else {
    jQuery('#product-grid-wrap').html('<div class="grid__item"><div class="grid-uniform u-mb"><p class="u-pt30" style="text-align: center; padding: 0 20px; margin-left: 30px;">Sorry, no products match your criteria. Please refine your search.</p></div></div>');
  }
  document.getElementById('product-grid-wrap').classList.remove('loading');
  // console.log('Products have been filtered!');
  // activeFilters = selectedColours
  // history.pushState(selectedColours, '', '?filters=' + selectedColours + selectedSizes);
}

// console.log('testing3');


  // var urlPath = window.location.pathname.split("/").pop(),
  //     $itemInput = $(".product-filter__item").find("input"),
  //     itemInputValue;

  //     // console.log(urlPath);

  // $itemInput.each(function() {
  //   itemInputValue = $(this).attr("value");
  //   // console.log(itemInputValue);

  //   if ( urlPath.indexOf(itemInputValue) > -1 ) {
  //     $(this).prop('checked', true).addClass("is-checked");
  //   }
  // });


function checkFilters() {
  // console.log('check Filters');
  if ( $(".template-collection").length ) {
    // console.log('template collection');
    // $(".product-filter__update").click();
    var currentHash = window.location.hash;
    var allHash = currentHash.slice(1);
    var hashArr = allHash.split(',');
    selectedColours = [];
    selectedFits = [];
    selectedSizes = [];
    var sortedBy;

    if(currentHash) {
      // console.log(currentHash);
      // console.log(allHash);
      // console.log(hashArr);
      var $itemInput = $(".product-filter__item").find("input"),
      itemInputValue;

      $itemInput.each(function() {
      itemInputValue = $(this).attr("value");
      // console.log(itemInputValue);

      if ( hashArr.indexOf(itemInputValue) > -1 ) {
        $(this).prop('checked', true).addClass("is-checked");
      }
    });


      for(var h = 0; h < hashArr.length; h++) {
        if(hashArr[h].includes('colour')) {
          selectedColours.push(hashArr[h]);
        }
        else if(hashArr[h].includes('fit')) {
          selectedFits.push(hashArr[h]);
        }
        else {
          selectedSizes.push(hashArr[h]);
        }
      }

      getProducts(selectedColours, selectedFits, selectedSizes, sortedBy);

      // console.log(selectedColours);
      // console.log(selectedFits);
      // console.log(selectedSizes);
    } else {
      document.getElementById('product-grid-wrap').classList.remove('loading');
    }
  }
}
checkFilters();


// window.onpopstate = function(event) {
//   alert("location: " + document.location + ", state: " + JSON.stringify(event.state));
// };
// window.onpopstate = function(e) {
//   console.log(e.state);
//   if (e.state !== null) {
//     outputProducts(e.State);
//   }
// }

// var selectedTags = [];
// var selectedColours = [];
// var selectedFits = [];
// var selectedSizes = [];

// $(".product-filter__form").find("input:checked").each(function() {
//   console.log('test');
//   console.log($(this));
//   if( selectedTags.includes( $(this).val() ) ) {
//     //do nothing
//   } else {
//     selectedTags.push($(this).val());
//     if( $(this).val().includes('colour-filter') ) {
//       selectedColours.push( $(this).val() );
//     }
//     else if( $(this).val().includes('fit') ) {
//       selectedFits.push( $(this).val() );
//     }
//     else {
//       selectedSizes.push($(this).val() );
//     }
//   }
// });

// if (selectedTags.length) {
// getProducts(selectedColours, selectedFits, selectedSizes);

// Accordion
function accordion() {
  $('.accordion .ac-toggle').on('click', function(){
    $(this).toggleClass('active');
    $(this).next('.ac-content').slideToggle(200);
  });
}
accordion();


// Update Price when selecting variants
function updatePriceOnChange() {
  if($('.template-product').length) {
    $('.product-sizes input').on('change', function(){
      var selected_option = $('.product-sizes input:checked'),
          product_price = selected_option.data('price'),
          compare_price = selected_option.data('compare-price'),
          product_price_num = parseFloat(product_price.replace(/[^0-9.-]+/g,'')),
          compare_price_num = parseFloat(compare_price.replace(/[^0-9.-]+/g,''));

      $('.price-wrap').removeClass('active');

      if(compare_price_num > product_price_num) {
        $('.compare-price-wrap').addClass('active');
        $('#ComparePrice .price').html(compare_price);
      }

      $('.product-price-wrap').addClass('active');
      $('#ProductPrice .pdp-price').html(product_price);

    });
  }
}
updatePriceOnChange();

function accountNav() {
  $('#dashboard').addClass('active');

  if (window.location.hash) {
    $('.account--column').removeClass('active');
    $('.account--column[data-account-section="' + window.location.hash.slice(1) + '"]').addClass('active');
    $('.account--menu-desktop li a').removeClass('active');
    $('.account--menu-desktop li a[data-account-nav="' + window.location.hash.slice(1) + '"]').addClass('active');
  }

  $('[data-account-nav]').on('click', function(e) {
    e.preventDefault();
    $('.account--menu-desktop li a').removeClass('active');
    $('.account--menu-desktop li a[data-account-nav="' + $(this).data('account-nav') + '"]').addClass('active');

    window.location.hash = $(this).data('account-nav');

    $('.account--column').removeClass('active');
    $('.account--column[data-account-section="' + $(this).data('account-nav') + '"]').addClass('active');
  })
}
accountNav();

function accountMenu() {
  $('.account--menu-mobile select').on('change', function () {
    selectedPage = $(this).find('option:selected');

    if(selectedPage.data('account-nav') != null) {
      window.location.hash = selectedPage.data('account-nav');
    } else {
      window.location.replace(selectedPage.data('href'));
    }

    $('.account--column').removeClass('active');
    $('.account--column[data-account-section="' + window.location.hash.slice(1) + '"]').addClass('active');
  });

  currentURL = window.location.pathname;
  $selectOption = $('.service-select').find('option');

  $selectOption.each(function () {
    selectURL = $(this).data('href');

    if (selectURL.indexOf(currentURL) > -1) {
      $(this).prop('selected', true);
    }
  });
}
accountMenu();

function defaultAddress() {
  $('[data-default-address]').on('click', function(e) {
    e.preventDefault();

    $('#EditAddress_' + $(this).data('default-address') + ' #address_default_address_' + $(this).data('default-address')).prop('checked', true);
    $('#EditAddress_' + $(this).data('default-address') + ' form').submit();
  })
}
defaultAddress();

function addressEdit() {
  $('.overlay-trigger').on('click', function() {
    $('body').addClass('no-scroll');
    $('.overlay-search').removeClass('is-hidden');
    $('.overlay-search').addClass('account-overlay');
  })

  $('.overlay-cancel').on('click', function () {
    $('body').removeClass('no-scroll');
    $('.overlay-search').addClass('is-hidden');
    $('.overlay-search').removeClass('account-overlay');
  })

  $('.overlay-search').on('click', function () {
    $('.form-vertical').hide();
  })
}
addressEdit();

function returnsLink() {
  if (Shopify.country === 'CA') {
    $('.return-us').hide();
  }

  if (Shopify.country === 'US') {
    $('.return-ca').hide();
  }

  if(Shopify.country !== 'CA' && Shopify.country !== 'US') {
    $('.return-ca').hide();
    $('.return-us').hide();
  }
}
returnsLink();
